import React from "react";
import { Color } from "ts/enums/color";

export enum IconType {
  alert = "alert",
  alertNoBgColor = "alertNoBgColor",
  arrowDown = "arrowDown",
  arrowLeft = "arrowLeft",
  arrowRight = "arrowRight",
  arrowRightThin = "arrowRightThin",
  arrowRightFat = "arrowRightFat",
  barChart = "barChart",
  bell = "bell",
  categories = "categories",
  check = "check",
  checkCircle = "checkCircle",
  checklist = "checklist",
  chevronUp = "chevronUp",
  chevronDown = "chevronDown",
  chevronLeft = "chevronLeft",
  chevronsLeft = "chevronsLeft",
  chevronRight = "chevronRight",
  chevronsRight = "chevronsRight",
  comment = "comment",
  commenters = "commenters",
  commentSearch = "commentSearch",
  trash = "trash",
  thumbUp = "thumbUp",
  thumbDown = "thumbDown",
  download = "download",
  dropdownArrow = "dropdownArrow",
  edit = "edit",
  enter = "enter",
  export = "export",
  externalLink = "externalLink",
  eye = "eye",
  eyeMinus = "eyeMinus",
  gauge = "gauge",
  gear = "gear",
  gearInGear = "gearInGear",
  group = "group",
  hierarchy = "hierarchy",
  hierarchySolid = "hierarchySolid",
  hierarchySolid2 = "hierarchySolid2",
  import = "import",
  info = "info",
  warning = "warning",
  layout = "layout",
  share = "share",
  merge = "merge",
  minus = "minus",
  minusCircle = "minusCircle",
  mixed = "mixed",
  negative = "negative",
  neutral = "neutral",
  notExplicit = "neutral", // same icon as neutral
  notepad = "notepad",
  notFound = "notFound",
  positive = "positive",
  plus = "plus",
  plusCircle = "plusCircle",
  print = "print",
  range = "range",
  recommendation = "recommendation",
  recommendationSolid = "recommendationSolid",
  refresh = "refresh",
  search = "search",
  searchFile = "searchFile",
  lockedFile = "lockedFile",
  lockedFileInverted = "lockedFileInverted",
  sentiment = "sentiment",
  topicsBanner = "topicsBanner",
  triangleFilledDown = "triangleFilledDown",
  triangleFilledRight = "triangleFilledRight",
  x = "x",
  xCircle = "xCircle",
  xSolid = "xSolid",
  warningSolid = "warningSolid",
  windows = "windows",
  topicSummary = "topicSummary",
  rearrangeArrows = "rearrangeArrows",
  commentBubble = "commentBubble",
  pin = "pin",
  horn = "horn",
  lightBulb = "lightBulb",

  // have default colors
  change = "change",
  commentChart = "commentChart",
  continue = "continue",
  doLess = "doLess",
  doMore = "doMore",
  mostNegativeTopics = "mostNegativeTopics",
  mostNegativeTopicsSolid = "mostNegativeTopicsSolid",
  mostPopularTopics = "mostPopularTopics",
  mostPopularTopicsSolid = "mostPopularTopicsSolid",
  mostPositiveTopics = "mostPositiveTopics",
  mostPositiveTopicsSolid = "mostPositiveTopicsSolid",
  allRecommendations = "allRecommendations",
  mostAlerts = "mostAlerts",
  allSentiments = "allSentiments",
  allSentimentsSolid = "allSentimentsSolid",
  prioritizedRecommendations = "prioritizedRecommendations",
  prioritizedRecommendationsSolid = "prioritizedRecommendationsSolid",
  categorizedRecommendations = "categorizedRecommendations",
  nothingToReport = "nothingToReport",
  redFlagAlert = "redFlagAlert",
  start = "start",
  stop = "stop",
  mly = "mly",
}

type Props = {
  type: IconType;
  size?: number;
  color?: Color;
  secondaryColor?: Color;
  className?: string;
  style?: Record<string, any>;
};
export const Icon = ({
  type,
  size = 20,
  color = Color.gray50,
  secondaryColor = Color.white,
  className,
  style,
  ...props
}: Props) => {
  const icons: any = {};

  const commonStyles = {
    flexShrink: 0,
  };

  const svgProps = {
    width: size,
    height: size,
    overflow: "visible",
    style: {
      ...commonStyles,
      ...style,
    },
    ...props,
  };

  icons.bell = (
    <svg {...svgProps} viewBox="0 0 10 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.39122 8.50098H9.55304C9.61322 8.49992 9.67297 8.51233 9.72799 8.53732C9.78302 8.56232 9.83203 8.5993 9.87166 8.6457C9.95705 8.74313 10.0029 8.87026 9.99986 9.00113C9.99717 9.14381 9.95413 9.28262 9.87604 9.40081C9.80891 9.5204 9.70627 9.61496 9.58308 9.67076C9.44295 9.73075 9.24327 9.80724 8.98401 9.90022C8.46107 10.0572 7.92913 10.1807 7.39118 10.2699C6.60255 10.4222 5.80183 10.4992 4.9993 10.5001C4.21698 10.5011 3.43603 10.4326 2.66527 10.2954C2.08902 10.2059 1.52115 10.0669 0.967661 9.87997L0.416156 9.67976C0.291926 9.62338 0.189051 9.52702 0.123195 9.40531C0.0459801 9.28479 0.00337452 9.14449 0.000181245 9.00039C-0.00326923 8.86945 0.0426588 8.74218 0.12838 8.64495C0.168004 8.59855 0.217022 8.56157 0.272045 8.53657C0.327067 8.51158 0.386723 8.49917 0.44691 8.50023H0.608812L1.73077 6.77029L2.32984 3.50088C2.43263 2.97231 2.68352 2.48584 3.05192 2.10089C3.41925 1.69294 3.89542 1.40431 4.42143 1.27079L4.25005 0.951346C4.23035 0.899304 4.22279 0.843284 4.22788 0.787714C4.23296 0.732143 4.25058 0.678544 4.27937 0.631153C4.31042 0.587024 4.35207 0.551881 4.40033 0.529147C4.44858 0.506413 4.50179 0.496866 4.55472 0.501429H5.44889C5.49954 0.496715 5.55062 0.503701 5.59828 0.52187C5.64594 0.540039 5.68903 0.568928 5.72433 0.606409C5.75359 0.648801 5.77153 0.698243 5.77654 0.749898C5.78155 0.801553 5.7734 0.853651 5.75285 0.901104L5.58147 1.27079C6.10875 1.3981 6.58612 1.68562 6.95098 2.09564C7.31922 2.48259 7.5703 2.97037 7.67386 3.50013L8.27293 6.76954L9.39489 8.49948L9.39122 8.50098ZM4.99707 11.4599C4.66977 11.461 4.34271 11.441 4.01788 11.3999C4.07774 11.6932 4.20845 11.9665 4.398 12.1948C4.46997 12.2875 4.5609 12.3628 4.66441 12.4155C4.76792 12.4683 4.88149 12.4971 4.99707 12.5C5.11275 12.4971 5.22645 12.4683 5.33008 12.4155C5.43371 12.3628 5.52473 12.2875 5.59685 12.1948C5.78548 11.9672 5.91315 11.6933 5.96741 11.3999C5.64554 11.4412 5.32145 11.4612 4.99707 11.4599Z"
        fill={color}
      />
    </svg>
  );

  icons.arrowDown = (
    <svg {...svgProps} viewBox="0 0 10.215 12.005">
      <path
        id="Path_2211"
        data-name="Path 2211"
        d="M169.152,5161.8v-8.579h1.79v8.579l2.947-2.947,1.265,1.266-5.107,5.107-5.107-5.107,1.265-1.266Z"
        transform="translate(-164.939 -5153.218)"
        fill={color}
      />
    </svg>
  );

  <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.42488 4.12374L12 4.12374L12 5.87624L3.42488 5.87624L6.37045 8.7615L5.10486 10L-2.18557e-07 4.99999L5.10486 -3.01396e-07L6.37045 1.23849L3.42488 4.12374Z"
      fill="#515C72"
    />
  </svg>;

  icons.arrowLeft = (
    <svg {...svgProps} viewBox="0 0 12 10" fill={color} xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.42488 4.12374L12 4.12374L12 5.87624L3.42488 5.87624L6.37045 8.7615L5.10486 10L-2.18557e-07 4.99999L5.10486 -3.01396e-07L6.37045 1.23849L3.42488 4.12374Z"
        fill={color}
      />
    </svg>
  );

  icons.arrowRight = (
    <svg {...svgProps} viewBox="0 0 12 10" fill={color} xmlns="http://www.w3.org/2000/svg">
      <path d="M0 4H8.576L6 1.238L7.238 0L12 5L7.238 10L6 8.762L8.576 6H0V4Z" fill={color} />
    </svg>
  );

  icons.arrowRightThin = (
    <svg {...svgProps} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24.279 9.414">
      <path
        id="Path_3481"
        data-name="Path 3481"
        d="M400.293,5153.707l2.293,2.293H382.135v2h20.451l-2.293,2.293,1.414,1.414,4.707-4.707-4.707-4.707Z"
        transform="translate(-382.135 -5152.293)"
        fill={color}
      />
    </svg>
  );

  icons.arrowRightFat = (
    <svg
      {...svgProps}
      width={size}
      height={(size * 22) / 29}
      viewBox="0 0 29 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.0057 10.1612C28.2281 10.3838 28.353 10.6856 28.353 11.0003C28.353 11.315 28.2281 11.6168 28.0057 11.8395L18.5057 21.3395C18.397 21.4562 18.2659 21.5497 18.1203 21.6146C17.9746 21.6795 17.8173 21.7144 17.6579 21.7173C17.4985 21.7201 17.3401 21.6907 17.1922 21.631C17.0443 21.5713 16.91 21.4824 16.7973 21.3696C16.6845 21.2569 16.5956 21.1225 16.5359 20.9747C16.4762 20.8268 16.4468 20.6684 16.4496 20.509C16.4524 20.3495 16.4873 20.1923 16.5523 20.0466C16.6172 19.901 16.7107 19.7699 16.8274 19.6612L24.3007 12.1878L1.83324 12.1878C1.51829 12.1878 1.21625 12.0627 0.993547 11.84C0.770849 11.6173 0.645738 11.3153 0.645738 11.0003C0.645738 10.6854 0.770849 10.3833 0.993547 10.1606C1.21625 9.93793 1.51829 9.81282 1.83324 9.81282L24.3007 9.81282L16.8274 2.33949C16.7107 2.23078 16.6172 2.09967 16.5523 1.95401C16.4873 1.80834 16.4524 1.6511 16.4496 1.49165C16.4468 1.3322 16.4762 1.17383 16.5359 1.02596C16.5956 0.878096 16.6845 0.743776 16.7973 0.631013C16.91 0.51825 17.0443 0.429354 17.1922 0.369629C17.3401 0.309905 17.4985 0.280574 17.6579 0.283387C17.8173 0.286201 17.9746 0.3211 18.1203 0.386004C18.2659 0.450908 18.397 0.544486 18.5057 0.661157L28.0057 10.1612Z"
        fill="#4230E5"
      />
    </svg>
  );

  icons.chevronUp = (
    <svg {...svgProps} fill={color} viewBox="0 0 8 4" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.00301 5.08466e-05C4.08129 -0.000117004 4.15881 0.0132554 4.23113 0.0393677C4.30344 0.06548 4.36913 0.103816 4.42432 0.152178L8 3.26604L7.15739 4L3.99988 1.24972L0.842612 4L-3.20825e-08 3.26604L3.57472 0.152178C3.63072 0.103088 3.69747 0.0643228 3.77104 0.0381876C3.84461 0.0120521 3.92357 -0.00091999 4.00301 5.08466e-05Z"
        fill={color}
      />
    </svg>
  );

  icons.chevronDown = (
    <svg {...svgProps} viewBox="0 0 12.25 7" fill={color}>
      <g id="Icons_Arrow_down" data-name="Icons/Arrow_down" transform="translate(-0.375 -0.625)">
        <path
          id="Icons_Arrow_down-2"
          data-name="Icons/Arrow_down"
          d="M6.737.249A.875.875,0,0,0,5.581.19L5.5.263.249,5.636A.875.875,0,0,0,.19,6.791l.074.082L5.514,12a.875.875,0,0,0,1.3-1.17l-.074-.082L2.113,6.233,6.751,1.487A.875.875,0,0,0,6.81.331Z"
          transform="translate(0.375 7.625) rotate(-90)"
        />
      </g>
    </svg>
  );

  icons.print = (
    <svg {...svgProps} viewBox="0 0 16 17" fill={color} xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_323_2144)">
        <path
          d="M14 7.1522C14 6.21959 13.19 5.45654 12.2 5.45654H11V6.58698H5V5.45654H3.8C2.81 5.45654 2 6.21959 2 7.1522V12.2392H3.8V14.5H12.2V12.2392H14V7.1522ZM11 13.3696H5V11.1087H11V13.3696ZM12.8 11.1087H12.2V9.97828H3.8V11.1087H3.2V7.1522C3.2 6.84133 3.47 6.58698 3.8 6.58698V7.71741H12.2V6.58698C12.53 6.58698 12.8 6.84133 12.8 7.1522V11.1087Z"
          fill="white"
        />
        <path
          d="M4.9998 2.63043H10.9998V4.8913H12.1998V1.5H3.7998V4.8913H4.9998V2.63043Z"
          fill="white"
        />
        <path
          d="M10.9999 9.41315C11.3313 9.41315 11.5999 9.16009 11.5999 8.84793C11.5999 8.53577 11.3313 8.28271 10.9999 8.28271C10.6685 8.28271 10.3999 8.53577 10.3999 8.84793C10.3999 9.16009 10.6685 9.41315 10.9999 9.41315Z"
          fill="white"
        />
      </g>
    </svg>
  );

  icons.triangleFilledDown = (
    <svg
      {...svgProps}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 8 4"
      className={className}
      fill={color}
    >
      <path
        id="Subtraction_68"
        data-name="Subtraction 68"
        d="M4,4,4,4,0,0H8L4,4Z"
        transform="translate(0)"
        fill={color}
      />
    </svg>
  );

  icons.thumbUp = (
    <svg {...svgProps} viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g>
        <path
          d="M15.3576 6.07333C15.24 5.92 15.0667 5.83333 14.881 5.83333H11.1667V3.16667C11.1667 2.8 10.8881 2.5 10.5476 2.5H8.69048C8.44286 2.5 8.22 2.66 8.12095 2.90667L6.42476 7.16667H6.21429C6.21429 6.8 5.93571 6.5 5.59524 6.5H3.11905C2.77857 6.5 2.5 6.8 2.5 7.16667V13.8333C2.5 14.2 2.77857 14.5 3.11905 14.5H5.59524C5.93571 14.5 6.21429 14.2 6.21429 13.8333V13.4867L8.46143 14.4533C8.53571 14.4867 8.61 14.5 8.69048 14.5H13.6429C13.94 14.5 14.2 14.2667 14.2495 13.9533L15.4876 6.62C15.5186 6.42667 15.469 6.22667 15.3514 6.07333H15.3576ZM4.97619 13.1667H3.7381V7.83333H4.97619V13.1667ZM13.1229 13.1667H8.80809L6.21429 12.0467V8.5H6.83333C7.08095 8.5 7.30381 8.34 7.40286 8.09333L9.09905 3.83333H9.92857V6.5C9.92857 6.86667 10.2071 7.16667 10.5476 7.16667H14.1381L13.1229 13.1667Z"
          fill={color}
        />
      </g>
    </svg>
  );

  icons.thumbDown = (
    <svg {...svgProps} viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g>
        <path
          d="M1.64238 10.9267C1.76 11.08 1.93333 11.1667 2.11905 11.1667L5.83333 11.1667L5.83333 13.8333C5.83333 14.2 6.1119 14.5 6.45238 14.5L8.30952 14.5C8.55714 14.5 8.78 14.34 8.87905 14.0933L10.5752 9.83333L10.7857 9.83333C10.7857 10.2 11.0643 10.5 11.4048 10.5L13.881 10.5C14.2214 10.5 14.5 10.2 14.5 9.83333L14.5 3.16667C14.5 2.8 14.2214 2.5 13.881 2.5L11.4048 2.5C11.0643 2.5 10.7857 2.8 10.7857 3.16667L10.7857 3.51333L8.53857 2.54667C8.46429 2.51333 8.39 2.5 8.30952 2.5L3.35714 2.5C3.06 2.5 2.8 2.73333 2.75048 3.04667L1.51238 10.38C1.48143 10.5733 1.53095 10.7733 1.64857 10.9267L1.64238 10.9267ZM12.0238 3.83333L13.2619 3.83333L13.2619 9.16667L12.0238 9.16667L12.0238 3.83333ZM3.87714 3.83333L8.19191 3.83333L10.7857 4.95333L10.7857 8.5L10.1667 8.5C9.91905 8.5 9.69619 8.66 9.59714 8.90667L7.90095 13.1667L7.07143 13.1667L7.07143 10.5C7.07143 10.1333 6.79286 9.83333 6.45238 9.83333L2.86191 9.83333L3.87714 3.83333Z"
          fill={color}
        />
      </g>
    </svg>
  );

  icons.checkCircle = (
    <svg {...svgProps} viewBox="0 0 16 16" fill={color}>
      <g id="Group_2236" data-name="Group 2236" transform="translate(0)">
        <g id="Group_2235" data-name="Group 2235">
          <path
            id="Path_2002"
            data-name="Path 2002"
            d="M143.017,67.15a8,8,0,1,1,8-8A8.01,8.01,0,0,1,143.017,67.15Zm0-14.4a6.4,6.4,0,1,0,6.4,6.4A6.407,6.407,0,0,0,143.017,52.75Z"
            transform="translate(-135.017 -51.15)"
          />
        </g>
      </g>
      <g id="Group_2238" data-name="Group 2238" transform="translate(4.184 4.308)">
        <g id="Group_2237" data-name="Group 2237">
          <path
            id="Path_2003"
            data-name="Path 2003"
            d="M143.295,63.971l-3.161-3.161,1.382-1.383,1.53,1.529,3.239-4.534,1.59,1.136Z"
            transform="translate(-140.133 -56.423)"
          />
        </g>
      </g>
    </svg>
  );

  icons.import = (
    <svg {...svgProps} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11.529 14">
      <path
        id="Icons_download"
        d="M159.686-51.182v-3.182l3.2,3.182Zm-1.281,4.455v3.182h-1.281v-3.182H155.2l2.562-2.545,2.562,2.545ZM160.592-55h-7.311A1.279,1.279,0,0,0,152-53.727v11.455A1.278,1.278,0,0,0,153.281-41h8.967a1.278,1.278,0,0,0,1.281-1.273v-9.809Z"
        transform="translate(-152 55)"
        fill={color}
        fillRule="evenodd"
      />
    </svg>
  );

  icons.gauge = (
    <svg {...svgProps} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14.785 10.753">
      <g id="Group_2728" data-name="Group 2728" transform="translate(233.555 -5285.704)">
        <path
          id="Path_2149"
          data-name="Path 2149"
          d="M-226.162,5285.7a7.4,7.4,0,0,0-7.393,7.392v3.361h14.785V5293.1A7.4,7.4,0,0,0-226.162,5285.7Zm-1.164,9.408a1.346,1.346,0,0,1,1.164-.672,1.345,1.345,0,0,1,1.163.672Zm7.212,0h-3.456a2.683,2.683,0,0,0-1.92-1.92v-2.784h-1.344v2.784a2.683,2.683,0,0,0-1.921,1.92h-3.456V5293.1a6.056,6.056,0,0,1,6.049-6.048,6.055,6.055,0,0,1,6.048,6.048Z"
          fill={color}
        />
        <g id="Group_2242" data-name="Group 2242">
          <g id="Group_2241" data-name="Group 2241">
            <circle
              id="Ellipse_8"
              data-name="Ellipse 8"
              cx="0.672"
              cy="0.672"
              r="0.672"
              transform="translate(-226.834 5287.72)"
              fill={color}
            />
          </g>
        </g>
        <g id="Group_2244" data-name="Group 2244">
          <g id="Group_2243" data-name="Group 2243">
            <path
              id="Path_2150"
              data-name="Path 2150"
              d="M-222.36,5290.245a.672.672,0,0,1-.951,0,.672.672,0,0,1,0-.951.674.674,0,0,1,.951,0A.674.674,0,0,1-222.36,5290.245Z"
              fill={color}
            />
          </g>
        </g>
        <g id="Group_2246" data-name="Group 2246">
          <g id="Group_2245" data-name="Group 2245">
            <circle
              id="Ellipse_9"
              data-name="Ellipse 9"
              cx="0.672"
              cy="0.672"
              r="0.672"
              transform="translate(-222.13 5292.424)"
              fill={color}
            />
          </g>
        </g>
        <g id="Group_2248" data-name="Group 2248">
          <g id="Group_2247" data-name="Group 2247">
            <path
              id="Path_2151"
              data-name="Path 2151"
              d="M-229.013,5290.245a.672.672,0,0,1-.951,0,.672.672,0,0,1,0-.951.673.673,0,0,1,.951,0A.673.673,0,0,1-229.013,5290.245Z"
              fill={color}
            />
          </g>
        </g>
        <g id="Group_2250" data-name="Group 2250">
          <g id="Group_2249" data-name="Group 2249">
            <circle
              id="Ellipse_10"
              data-name="Ellipse 10"
              cx="0.672"
              cy="0.672"
              r="0.672"
              transform="translate(-231.539 5292.424)"
              fill={color}
            />
          </g>
        </g>
      </g>
    </svg>
  );

  icons.barChart = (
    <svg {...svgProps} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10.48 15.722">
      <path
        id="Path_2208"
        data-name="Path 2208"
        d="M428.19,1029.412h8.516a.656.656,0,0,0,.655-.655v-2.62a.656.656,0,0,0-.655-.655H428.19v-.655h4.586a.655.655,0,0,0,.655-.655v-2.62a.655.655,0,0,0-.655-.655H428.19v-.655h5.9a.655.655,0,0,0,.655-.655v-2.62a.655.655,0,0,0-.655-.655h-5.9V1015h-1.31v15.722h1.31Zm7.861-2.62v1.31H428.19v-1.31Zm-3.93-4.586v1.31h-3.93v-1.31Zm1.31-4.586v1.31H428.19v-1.31Z"
        transform="translate(-426.881 -1015)"
        fill={color}
      />
    </svg>
  );

  icons.hierarchy = (
    <svg {...svgProps} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13.441 14.449">
      <path
        id="Path_2207"
        data-name="Path 2207"
        d="M-237.237,5344.277v-2.14h-4.7v-1.344h2.885l-.218-.841a3.352,3.352,0,0,0-2.434-2.408,2.012,2.012,0,0,0,1.111-1.792,2.018,2.018,0,0,0-2.016-2.016,2.018,2.018,0,0,0-2.016,2.016,2.012,2.012,0,0,0,1.111,1.792,3.352,3.352,0,0,0-2.434,2.408l-.218.841h2.885v1.344h-4.705v2.14a2.013,2.013,0,0,0-1.344,1.892,2.019,2.019,0,0,0,2.016,2.016,2.019,2.019,0,0,0,2.017-2.016,2.013,2.013,0,0,0-1.344-1.892v-.8h3.36v.8a2.012,2.012,0,0,0-1.344,1.892,2.018,2.018,0,0,0,2.016,2.016,2.018,2.018,0,0,0,2.016-2.016,2.012,2.012,0,0,0-1.344-1.892v-.8h3.36v.8a2.013,2.013,0,0,0-1.344,1.892,2.019,2.019,0,0,0,2.016,2.016,2.019,2.019,0,0,0,2.017-2.016A2.013,2.013,0,0,0-237.237,5344.277Zm-5.376-9.2a.673.673,0,0,1,.672.672.673.673,0,0,1-.672.672.672.672,0,0,1-.672-.672A.673.673,0,0,1-242.613,5335.08Zm-.095,3.7h.19a2,2,0,0,1,1.494.672H-244.2A2,2,0,0,1-242.708,5338.776Zm-4.61,8.065a.673.673,0,0,1-.672-.672.673.673,0,0,1,.672-.672.673.673,0,0,1,.673.672A.673.673,0,0,1-247.318,5346.841Zm4.7,0a.672.672,0,0,1-.672-.672.673.673,0,0,1,.672-.672.673.673,0,0,1,.672.672A.673.673,0,0,1-242.613,5346.841Zm4.7,0a.673.673,0,0,1-.672-.672.673.673,0,0,1,.672-.672.673.673,0,0,1,.672.672A.672.672,0,0,1-237.909,5346.841Z"
        transform="translate(249.334 -5333.736)"
        fill={color}
      />
    </svg>
  );

  icons.redFlagAlert = (
    <svg {...svgProps} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13.121 11.888">
      <g id="alert-icon" transform="translate(3156.355 -11947.205)">
        <g id="alert-3" transform="translate(-3155.795 11947.749)">
          <path
            id="Path_3890"
            data-name="Path 3890"
            d="M1.209,10.914,5.987,2.235a1.307,1.307,0,0,1,2.2,0l4.778,8.679a1.077,1.077,0,0,1-1.1,1.518H2.31A1.077,1.077,0,0,1,1.209,10.914Z"
            transform="translate(-1.088 -1.632)"
            fill={Color.red20}
            stroke={Color.red30}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.088"
          />
          <path
            id="Path_3891"
            data-name="Path 3891"
            d="M6.528,4.9V7.072"
            transform="translate(-0.528 -1.2)"
            fill="none"
            stroke={Color.red30}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.088"
          />
          <path
            id="Path_3892"
            data-name="Path 3892"
            d="M6.528,9.259V9.248"
            transform="translate(-0.528 -0.847)"
            fill="none"
            stroke={Color.red30}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.088"
          />
        </g>
      </g>
    </svg>
  );

  icons.warning = (
    <svg
      {...svgProps}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 13.121 11.888"
      className="is-stroke"
    >
      <g id="alert-icon-gray" transform="translate(3156.355 -11947.205)">
        <g id="alert-3" transform="translate(-3155.795 11947.749)">
          <path
            id="Path_3890"
            data-name="Path 3890"
            d="M1.209,10.914,5.987,2.235a1.307,1.307,0,0,1,2.2,0l4.778,8.679a1.077,1.077,0,0,1-1.1,1.518H2.31A1.077,1.077,0,0,1,1.209,10.914Z"
            transform="translate(-1.088 -1.632)"
            fill="none"
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.088"
          />
          <path
            id="Path_3891"
            data-name="Path 3891"
            d="M6.528,4.9V7.072"
            transform="translate(-0.528 -1.2)"
            fill="none"
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.088"
          />
          <path
            id="Path_3892"
            data-name="Path 3892"
            d="M6.528,9.259V9.248"
            transform="translate(-0.528 -0.847)"
            fill="none"
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.088"
          />
        </g>
      </g>
    </svg>
  );

  icons.nothingToReport = (
    <svg {...svgProps} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13.121 11.888">
      <g id="alert-icon-gray" transform="translate(3156.355 -11947.205)">
        <g id="alert-3" transform="translate(-3155.795 11947.749)">
          <path
            id="Path_3890"
            data-name="Path 3890"
            d="M1.209,10.914,5.987,2.235a1.307,1.307,0,0,1,2.2,0l4.778,8.679a1.077,1.077,0,0,1-1.1,1.518H2.31A1.077,1.077,0,0,1,1.209,10.914Z"
            transform="translate(-1.088 -1.632)"
            fill={Color.gray20}
            stroke={Color.gray50}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.088"
          />
          <path
            id="Path_3891"
            data-name="Path 3891"
            d="M6.528,4.9V7.072"
            transform="translate(-0.528 -1.2)"
            fill="none"
            stroke={Color.gray50}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.088"
          />
          <path
            id="Path_3892"
            data-name="Path 3892"
            d="M6.528,9.259V9.248"
            transform="translate(-0.528 -0.847)"
            fill="none"
            stroke={Color.gray50}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.088"
          />
        </g>
      </g>
    </svg>
  );

  icons.comment = (
    <svg {...svgProps} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22.036 22.032">
      <g id="Group_3783" data-name="Group 3783" transform="translate(31.257 -1466.39)">
        <path
          id="Path_2325"
          data-name="Path 2325"
          d="M-10.092,1473.13a10.936,10.936,0,0,0-6-5.922,10.935,10.935,0,0,0-8.429.054,10.943,10.943,0,0,0-5.923,6,10.949,10.949,0,0,0,.084,8.484l-.858,4.291a2,2,0,0,0,.546,1.8,2.2,2.2,0,0,0,1.422.587,1.908,1.908,0,0,0,.389-.039l4.338-.825a11.066,11.066,0,0,0,8.561,0,10.944,10.944,0,0,0,5.923-6A10.946,10.946,0,0,0-10.092,1473.13Zm-1.8,7.677a8.954,8.954,0,0,1-4.847,4.909,9.059,9.059,0,0,1-6.986.008,2.184,2.184,0,0,0-1.248-.156l-4.284.854h0l0,0v0l.865-4.322a2.063,2.063,0,0,0-.155-1.187,8.954,8.954,0,0,1-.044-6.9,8.956,8.956,0,0,1,4.847-4.91,9,9,0,0,1,3.5-.713,8.987,8.987,0,0,1,3.4.67,8.951,8.951,0,0,1,4.909,4.847A8.954,8.954,0,0,1-11.891,1480.807Z"
          fill={color}
        />
        <circle
          id="Ellipse_96"
          data-name="Ellipse 96"
          cx="1"
          cy="1"
          r="1"
          transform="translate(-25.078 1476.204)"
          fill={color}
        />
        <circle
          id="Ellipse_97"
          data-name="Ellipse 97"
          cx="1"
          cy="1"
          r="1"
          transform="translate(-21.078 1476.204)"
          fill={color}
        />
        <circle
          id="Ellipse_98"
          data-name="Ellipse 98"
          cx="1"
          cy="1"
          r="1"
          transform="translate(-17.078 1476.204)"
          fill={color}
        />
      </g>
    </svg>
  );

  icons.dropdownArrow = (
    <svg {...svgProps} viewBox="0 0 7.884 5.039">
      <path
        id="Combined_Shape"
        data-name="Combined Shape"
        d="M5,.8A.91.91,0,0,0,3.466.137L.248,3.167a.91.91,0,0,0,0,1.325l3.218,3.03A.91.91,0,0,0,5,6.86Z"
        transform="translate(0.112 5) rotate(-90)"
        fill={color}
      />
    </svg>
  );

  icons.edit = (
    <svg {...svgProps} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12.019 12.019">
      <path
        id="Path_2227"
        data-name="Path 2227"
        d="M61.984,252.034a1.934,1.934,0,0,0-2.67,0l-6.82,6.82a.616.616,0,0,0-.113.157l-1.819,3.637a.6.6,0,0,0,.807.806l3.638-1.818a.564.564,0,0,0,.156-.113l6.82-6.82A1.933,1.933,0,0,0,61.984,252.034Zm-7.6,8.57-1.935.967.968-1.936,5.416-5.415.967.968Zm6.751-6.751-.484.484-.967-.968.484-.484a.7.7,0,0,1,.967,0A.686.686,0,0,1,61.133,253.854Z"
        transform="translate(-50.5 -251.5)"
        fill={color}
      />
    </svg>
  );

  icons.trash = (
    <svg {...svgProps} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12.005 12.672">
      <g id="Group_2787" data-name="Group 2787" transform="translate(-483 -252)">
        <g id="Group_2767" data-name="Group 2767" transform="translate(483 252)">
          <path
            id="Path_2216"
            data-name="Path 2216"
            d="M485,265a1.335,1.335,0,0,0,1.334,1.334H493A1.335,1.335,0,0,0,494.337,265v-8H485Zm1.334-6.669H493V265h-6.67Z"
            transform="translate(-483.666 -253.665)"
            fill={color}
          />
          <path
            id="Path_2217"
            data-name="Path 2217"
            d="M491,253.334V252h-4v1.334h-4v1.334h12v-1.334Z"
            transform="translate(-483 -252)"
            fill={color}
          />
          <rect
            id="Rectangle_1330"
            data-name="Rectangle 1330"
            width="1.334"
            height="4.002"
            transform="translate(4.002 6.002)"
            fill={color}
          />
          <rect
            id="Rectangle_1331"
            data-name="Rectangle 1331"
            width="1.334"
            height="4.002"
            transform="translate(6.669 6.002)"
            fill={color}
          />
        </g>
      </g>
    </svg>
  );

  icons.externalLink = (
    <svg
      {...svgProps}
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1303_1093)">
        <path
          d="M12.6667 12.1466C12.6667 12.7066 12.2067 13.1666 11.6467 13.1666H4.35333C3.79333 13.1666 3.33333 12.7066 3.33333 12.1466V4.85329C3.33333 4.29329 3.79333 3.83329 4.35333 3.83329H7.33333V2.49995H4.35333C3.05333 2.49995 2 3.55329 2 4.85329V12.1466C2 13.4466 3.05333 14.5 4.35333 14.5H11.6467C12.9467 14.5 14 13.4466 14 12.1466V9.16662H12.6667V12.1466ZM11.6467 2.49995H9.33333V3.83329H11.6467C11.6467 3.83329 11.6933 3.83329 11.72 3.83329C12.22 3.86662 12.6267 4.27329 12.66 4.77329C12.6667 4.79995 12.6667 4.81995 12.6667 4.84662V7.15995H14V4.84662C14 3.54662 12.9467 2.49329 11.6467 2.49329V2.49995Z"
          fill={color}
        />
        <path
          d="M14.0001 2.5V7.16667H12.6668V4.77333L12.6601 4.78L9.80677 7.64L8.86011 6.69333L11.7201 3.84L11.7268 3.83333H9.33344V2.5H14.0001Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_1303_1093">
          <rect width="12" height="12" fill={color} transform="translate(2 2.5)" />
        </clipPath>
      </defs>
    </svg>
  );

  icons.eye = (
    <svg
      {...svgProps}
      id="Group_2788"
      data-name="Group 2788"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16.001 12.065"
    >
      <path
        id="Path_1902"
        data-name="Path 1902"
        d="M10.726,309.642a3.17,3.17,0,1,0,3.17,3.17A3.173,3.173,0,0,0,10.726,309.642Zm0,5.182a2.012,2.012,0,1,1,2.012-2.012A2.014,2.014,0,0,1,10.726,314.824Z"
        transform="translate(-2.725 -306.776)"
        fill={color}
      />
      <path
        id="Path_1903"
        data-name="Path 1903"
        d="M16,311.192a.529.529,0,0,0-.012-.115c0-.02,0-.039-.006-.059a8.367,8.367,0,0,0-15.965,0,.43.43,0,0,0-.006.057.557.557,0,0,0,0,.231.446.446,0,0,0,.006.059,8.367,8.367,0,0,0,15.965,0,.576.576,0,0,0,.006-.058A.533.533,0,0,0,16,311.192Zm-8,4.874a7.172,7.172,0,0,1-6.807-4.874,7.191,7.191,0,0,1,13.615,0A7.172,7.172,0,0,1,8,316.066Z"
        transform="translate(0 -305.159)"
        fill={color}
      />
    </svg>
  );

  icons.eyeMinus = (
    <svg
      {...svgProps}
      width={size}
      height={(size * 5) / 6}
      viewBox="0 0 12 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_936_18820)">
        <path
          d="M11.6327 5.79573C11.5345 5.66748 9.18229 2.65625 5.86546 2.65625C2.54863 2.65625 0.196409 5.66823 0.0974116 5.79573C0.0341768 5.8782 0.000244141 5.97659 0.000244141 6.07739C0.000244141 6.1782 0.0341768 6.27654 0.0974116 6.35901C0.196409 6.48726 2.5519 9.49849 5.86546 9.49849C9.17902 9.49849 11.5345 6.48651 11.6327 6.35901C11.6963 6.27666 11.7304 6.17827 11.7304 6.07739C11.7304 5.97651 11.6963 5.87808 11.6327 5.79573ZM5.86546 8.52126C3.64415 8.52126 1.8401 6.77373 1.21011 6.07698C1.83846 5.38023 3.63679 3.63348 5.86546 3.63348C8.09414 3.63348 9.89083 5.38176 10.5208 6.07776C9.89164 6.77526 8.09414 8.52126 5.86464 8.52126H5.86546Z"
          fill="#35384D"
        />
        <path d="M12 0.5H7.28735V1.94H12V0.5Z" fill="#35384D" />
        <path
          d="M5.86537 4.125C5.44351 4.125 5.03113 4.23965 4.68037 4.4545C4.32961 4.66934 4.05622 4.97471 3.89478 5.33199C3.73334 5.68926 3.69111 6.08242 3.77341 6.4617C3.85571 6.84098 4.05885 7.18938 4.35715 7.46283C4.65545 7.73628 5.0355 7.92247 5.44926 7.99791C5.86301 8.07335 6.29187 8.03466 6.68162 7.88667C7.07137 7.73868 7.40449 7.48806 7.63886 7.16652C7.87323 6.84498 7.99833 6.46696 7.99833 6.08025C7.99789 5.5618 7.77303 5.06471 7.37312 4.69812C6.97321 4.33153 6.43093 4.1254 5.86537 4.125ZM5.86537 7.05748C5.65501 7.05748 5.44937 7.00032 5.27446 6.89319C5.09955 6.78605 4.96323 6.63377 4.88272 6.45561C4.80222 6.27745 4.78116 6.08142 4.8222 5.89229C4.86324 5.70316 4.96454 5.52941 5.11328 5.39305C5.26203 5.25669 5.45155 5.16384 5.65787 5.12622C5.86419 5.0886 6.07805 5.10791 6.2724 5.1817C6.46675 5.2555 6.63286 5.38048 6.74974 5.54082C6.86661 5.70116 6.92899 5.88965 6.92899 6.08249C6.92899 6.34108 6.81693 6.58908 6.61746 6.77193C6.41799 6.95477 6.14746 7.05748 5.86537 7.05748Z"
          fill="#35384D"
        />
      </g>
      <defs>
        <clipPath id="clip0_936_18820">
          <rect width="12" height="9" fill="white" transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </svg>
  );

  icons.xSolid = (
    <svg {...svgProps} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
      <path
        id="Path_2326"
        data-name="Path 2326"
        d="M-134,2326a8,8,0,0,0-8,8,8,8,0,0,0,8,8,8,8,0,0,0,8-8A8,8,0,0,0-134,2326Zm3.613,11.032-.581.581-3.032-3.023-3.032,3.023-.581-.581,3.023-3.032-3.023-3.032.581-.581,3.032,3.023,3.032-3.023.581.581-3.023,3.032Z"
        transform="translate(142 -2326)"
        fill={color}
      />
    </svg>
  );

  icons.x = (
    <svg
      {...svgProps}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="is-stroke"
      {...props}
    >
      <line x1="18" y1="6" x2="6" y2="18"></line>
      <line x1="6" y1="6" x2="18" y2="18"></line>
    </svg>
  );

  icons.refresh = (
    <svg {...svgProps} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.007 16.005">
      <g id="refresh" transform="translate(21.214 -4830.712)">
        <path
          id="Path_2353"
          data-name="Path 2353"
          d="M-17.935,4834.193a6.357,6.357,0,0,1,4.522-1.881,6.41,6.41,0,0,1,6.4,6.4h1.6a8.012,8.012,0,0,0-8-8,7.947,7.947,0,0,0-5.653,2.352l-1.551-1.551v4.8h4.8Z"
          transform="translate(0.202)"
          fill={color}
        />
        <path
          id="Path_2354"
          data-name="Path 2354"
          d="M-8.69,4841.216a6.354,6.354,0,0,1-4.521,1.881,6.411,6.411,0,0,1-6.4-6.4h-1.6a8.011,8.011,0,0,0,8,8,7.94,7.94,0,0,0,5.651-2.352l1.551,1.552v-4.8h-4.8Z"
          transform="translate(0 2.021)"
          fill={color}
        />
      </g>
    </svg>
  );

  icons.xCircle = (
    <svg {...svgProps} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
      <g id="xCircle" transform="translate(-16075 7417)">
        <path
          id="Path_2370"
          data-name="Path 2370"
          d="M60,4955a10,10,0,1,0,10,10A10.011,10.011,0,0,0,60,4955Zm0,18a8,8,0,1,1,8-8A8.009,8.009,0,0,1,60,4973Z"
          transform="translate(16025 -12372)"
          fill={color}
        />
        <path
          id="Path_2371"
          data-name="Path 2371"
          d="M62.293,4961.293,60,4963.586l-2.293-2.293-1.414,1.414L58.586,4965l-2.293,2.293,1.414,1.414L60,4966.414l2.293,2.293,1.414-1.414L61.414,4965l2.293-2.293Z"
          transform="translate(16025 -12372)"
          fill={color}
        />
      </g>
    </svg>
  );

  icons.plusCircle = (
    <svg
      {...svgProps}
      id="Group_4369"
      data-name="Group 4369"
      viewBox="0 0 12.825 12.825"
      fill={color}
    >
      <g id="Group_2227" data-name="Group 2227" transform="translate(0 0)">
        <path
          id="Path_1997"
          data-name="Path 1997"
          d="M348.492,53.031a6.415,6.415,0,1,0,0,9.073A6.422,6.422,0,0,0,348.492,53.031ZM340.327,61.2a5.132,5.132,0,1,1,7.259,0A5.138,5.138,0,0,1,340.327,61.2Z"
          transform="translate(-337.543 -51.154)"
          fill={color}
        />
      </g>
      <g id="Group_2228" data-name="Group 2228" transform="translate(3.691 3.691)">
        <path
          id="Path_1998"
          data-name="Path 1998"
          d="M348.74,58.987h-2.08v-2.08h-1.283v2.08H343.3V60.27h2.08v2.08h1.283V60.27h2.08Z"
          transform="translate(-343.296 -56.907)"
          fill={color}
        />
      </g>
    </svg>
  );

  icons.check = (
    <svg
      {...svgProps}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="is-stroke"
    >
      <polyline points="20 6 9 17 4 12"></polyline>
    </svg>
  );

  icons.checklist = (
    <svg {...svgProps} id="Group_4370" data-name="Group 4370" viewBox="0 0 12.002 12.002">
      <path
        id="Path_1850"
        data-name="Path 1850"
        d="M3,47.661H.6a.6.6,0,0,0-.6.6v2.4a.6.6,0,0,0,.6.6H3a.6.6,0,0,0,.6-.6v-2.4A.6.6,0,0,0,3,47.661Zm-.6,2.4H1.2v-1.2H2.4Z"
        transform="translate(0 -47.661)"
        fill={color}
      />
      <path
        id="Path_1851"
        data-name="Path 1851"
        d="M3,56.963H.6a.6.6,0,0,0-.6.6v2.4a.6.6,0,0,0,.6.6H3a.6.6,0,0,0,.6-.6v-2.4A.6.6,0,0,0,3,56.963Zm-.6,2.4H1.2v-1.2H2.4Z"
        transform="translate(0 -52.762)"
        fill={color}
      />
      <path
        id="Path_1852"
        data-name="Path 1852"
        d="M3,66.265H.6a.6.6,0,0,0-.6.6v2.4a.6.6,0,0,0,.6.6H3a.6.6,0,0,0,.6-.6v-2.4A.6.6,0,0,0,3,66.265Zm-.6,2.4H1.2v-1.2H2.4Z"
        transform="translate(0 -57.864)"
        fill={color}
      />
      <rect
        id="Rectangle_1169"
        data-name="Rectangle 1169"
        width="7.201"
        height="1.2"
        transform="translate(4.801 1.2)"
        fill={color}
      />
      <rect
        id="Rectangle_1170"
        data-name="Rectangle 1170"
        width="7.201"
        height="1.2"
        transform="translate(4.801 5.401)"
        fill={color}
      />
      <rect
        id="Rectangle_1171"
        data-name="Rectangle 1171"
        width="7.201"
        height="1.2"
        transform="translate(4.801 9.601)"
        fill={color}
      />
    </svg>
  );

  icons.search = (
    <svg {...svgProps} viewBox="0 0 13.938 13.938">
      <path
        id="Path_2493"
        data-name="Path 2493"
        d="M-22,3885.986l-3.635-3.639a5.741,5.741,0,0,0,1.247-3.573A5.782,5.782,0,0,0-30.168,3873a5.781,5.781,0,0,0-5.775,5.775,5.781,5.781,0,0,0,5.775,5.774,5.746,5.746,0,0,0,3.577-1.25l3.634,3.639Zm-8.164-2.784a4.433,4.433,0,0,1-4.428-4.428,4.434,4.434,0,0,1,4.428-4.429,4.434,4.434,0,0,1,4.429,4.429A4.433,4.433,0,0,1-30.168,3883.2Z"
        transform="translate(35.943 -3873)"
        fill={color}
      />
    </svg>
  );

  icons.searchFile = (
    <svg {...svgProps} viewBox="0 0 10 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g>
        <path
          d="M7.03328 7.74013C7.14995 7.4565 7.22217 7.14559 7.22217 6.81832C7.22217 5.46559 6.09995 4.36377 4.72217 4.36377C3.34439 4.36377 2.22217 5.46559 2.22217 6.81832C2.22217 8.17104 3.34439 9.27286 4.72217 9.27286C5.0555 9.27286 5.37217 9.20741 5.66106 9.09286L6.27772 9.69832C6.46106 9.87832 6.7055 9.9765 6.96661 9.9765C7.22772 9.9765 7.47217 9.87832 7.6555 9.69832C8.03328 9.32741 8.03328 8.72195 7.6555 8.35104L7.03884 7.74559L7.03328 7.74013ZM4.72217 8.18195C3.9555 8.18195 3.33328 7.57104 3.33328 6.81832C3.33328 6.06559 3.9555 5.45468 4.72217 5.45468C5.48883 5.45468 6.11106 6.06559 6.11106 6.81832C6.11106 7.57104 5.48883 8.18195 4.72217 8.18195Z"
          fill={color}
        />
        <path
          d="M7.45 0H1.11111C0.5 0 0 0.490909 0 1.09091V10.9091C0 11.5091 0.5 12 1.11111 12H8.88889C9.5 12 10 11.5091 10 10.9091V2.50364L7.45 0ZM1.11111 10.9091V1.09091H6.66667V3.27273H8.88889V10.9091H1.11111Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_1474_2771">
          <rect width="10" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );

  icons.enter = (
    <svg
      {...svgProps}
      style={{ display: "block", transform: "scale(-1, 1)" }}
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
    >
      <path d="M19,6a1,1,0,0,0-1,1v4a1,1,0,0,1-1,1H7.41l1.3-1.29A1,1,0,0,0,7.29,9.29l-3,3a1,1,0,0,0-.21.33,1,1,0,0,0,0,.76,1,1,0,0,0,.21.33l3,3a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42L7.41,14H17a3,3,0,0,0,3-3V7A1,1,0,0,0,19,6Z" />
    </svg>
  );

  icons.alert = (
    <svg
      {...svgProps}
      viewBox="0 0 24 24"
      className="is-stroke"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="10" fill="none"></circle>
      <line x1="12" y1="8" x2="12" y2="12"></line>
      <line x1="12" y1="16" x2="12.01" y2="16"></line>
    </svg>
  );

  icons.hierarchySolid = (
    <svg {...svgProps} viewBox="0 0 12 12">
      <path
        id="Path_2511"
        data-name="Path 2511"
        d="M949.4,2610.775h-1.2v-.6a1.8,1.8,0,0,0-1.8-1.8h-1.8v-1.2h1.2a.6.6,0,0,0,.6-.6v-3a.6.6,0,0,0-.6-.6h-3.6a.6.6,0,0,0-.6.6v3a.6.6,0,0,0,.6.6h1.2v1.2h-1.8a1.8,1.8,0,0,0-1.8,1.8v.6h-1.2a.6.6,0,0,0-.6.6v3a.6.6,0,0,0,.6.6h3.6a.6.6,0,0,0,.6-.6v-3a.6.6,0,0,0-.6-.6H941v-.6a.6.6,0,0,1,.6-.6h4.8a.6.6,0,0,1,.6.6v.6h-1.2a.6.6,0,0,0-.6.6v3a.6.6,0,0,0,.6.6h3.6a.6.6,0,0,0,.6-.6v-3A.6.6,0,0,0,949.4,2610.775Z"
        transform="translate(-938 -2602.975)"
        fill={color}
      />
    </svg>
  );

  icons.chevronRight = (
    <svg
      {...svgProps}
      stroke={color}
      viewBox="0 0 24 24"
      fill="none"
      className="is-stroke"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="9 18 15 12 9 6"></polyline>
    </svg>
  );

  icons.chevronLeft = (
    <svg
      {...svgProps}
      stroke={color}
      viewBox="0 0 24 24"
      fill="none"
      className="is-stroke"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="15 18 9 12 15 6"></polyline>
    </svg>
  );

  icons.positive = (
    <svg {...svgProps} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 2H4C2.89543 2 2 2.89543 2 4V12C2 13.1046 2.89543 14 4 14H12C13.1046 14 14 13.1046 14 12V4C14 2.89543 13.1046 2 12 2Z"
        fill={secondaryColor}
      />
      <path
        d="M12 2.5H4C3.17157 2.5 2.5 3.17157 2.5 4V12C2.5 12.8284 3.17157 13.5 4 13.5H12C12.8284 13.5 13.5 12.8284 13.5 12V4C13.5 3.17157 12.8284 2.5 12 2.5Z"
        stroke={color}
      />
      <path
        d="M6.58982 6.88228C7.0438 6.88228 7.41182 6.51426 7.41182 6.06028C7.41182 5.6063 7.0438 5.23828 6.58982 5.23828C6.13584 5.23828 5.76782 5.6063 5.76782 6.06028C5.76782 6.51426 6.13584 6.88228 6.58982 6.88228Z"
        fill={color}
      />
      <path
        d="M9.40989 6.88228C9.86387 6.88228 10.2319 6.51426 10.2319 6.06028C10.2319 5.6063 9.86387 5.23828 9.40989 5.23828C8.95591 5.23828 8.58789 5.6063 8.58789 6.06028C8.58789 6.51426 8.95591 6.88228 9.40989 6.88228Z"
        fill={color}
      />
      <path
        d="M7.99991 9.12231C7.5433 9.124 7.09265 9.01852 6.68417 8.81445C6.2757 8.61039 5.92076 8.31338 5.64789 7.94727L4.4729 8.8313C4.88394 9.37845 5.41665 9.82249 6.02887 10.1283C6.64109 10.4341 7.31605 10.5933 8.0004 10.5933C8.68475 10.5933 9.35973 10.4341 9.97195 10.1283C10.5842 9.82249 11.1168 9.37845 11.5279 8.8313L10.3519 7.94727C10.0792 8.31355 9.72431 8.61074 9.3158 8.81482C8.90728 9.0189 8.45656 9.12423 7.99991 9.12231Z"
        fill={color}
      />
    </svg>
  );

  icons.negative = (
    <svg {...svgProps} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 2H4C2.89543 2 2 2.89543 2 4V12C2 13.1046 2.89543 14 4 14H12C13.1046 14 14 13.1046 14 12V4C14 2.89543 13.1046 2 12 2Z"
        fill={secondaryColor}
      />
      <path
        d="M12 2.5H4C3.17157 2.5 2.5 3.17157 2.5 4V12C2.5 12.8284 3.17157 13.5 4 13.5H12C12.8284 13.5 13.5 12.8284 13.5 12V4C13.5 3.17157 12.8284 2.5 12 2.5Z"
        stroke={color}
      />
      <path
        d="M6.58982 6.88228C7.0438 6.88228 7.41182 6.51426 7.41182 6.06028C7.41182 5.6063 7.0438 5.23828 6.58982 5.23828C6.13584 5.23828 5.76782 5.6063 5.76782 6.06028C5.76782 6.51426 6.13584 6.88228 6.58982 6.88228Z"
        fill={color}
      />
      <path
        d="M9.40989 6.88228C9.86387 6.88228 10.2319 6.51426 10.2319 6.06028C10.2319 5.6063 9.86387 5.23828 9.40989 5.23828C8.95591 5.23828 8.58789 5.6063 8.58789 6.06028C8.58789 6.51426 8.95591 6.88228 9.40989 6.88228Z"
        fill={color}
      />
      <path
        d="M7.99991 9.41638C7.5434 9.41466 7.09281 9.52 6.68436 9.72388C6.2759 9.92776 5.92092 10.2245 5.64789 10.5903L4.4729 9.70642C4.88407 9.15945 5.41679 8.71547 6.02899 8.40979C6.6412 8.10411 7.31612 7.94507 8.0004 7.94507C8.68468 7.94507 9.3596 8.10411 9.9718 8.40979C10.584 8.71547 11.1167 9.15945 11.5279 9.70642L10.3519 10.5894C10.079 10.2234 9.72399 9.92663 9.31549 9.7229C8.90699 9.51917 8.45639 9.41423 7.99991 9.41638Z"
        fill={color}
      />
    </svg>
  );

  icons.neutral = (
    <svg {...svgProps} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 2H4C2.89543 2 2 2.89543 2 4V12C2 13.1046 2.89543 14 4 14H12C13.1046 14 14 13.1046 14 12V4C14 2.89543 13.1046 2 12 2Z"
        fill={secondaryColor}
      />
      <path
        d="M12 2.5H4C3.17157 2.5 2.5 3.17157 2.5 4V12C2.5 12.8284 3.17157 13.5 4 13.5H12C12.8284 13.5 13.5 12.8284 13.5 12V4C13.5 3.17157 12.8284 2.5 12 2.5Z"
        stroke={color}
      />
      <path
        d="M6.59007 6.88228C7.04404 6.88228 7.41207 6.51426 7.41207 6.06028C7.41207 5.6063 7.04404 5.23828 6.59007 5.23828C6.13609 5.23828 5.76807 5.6063 5.76807 6.06028C5.76807 6.51426 6.13609 6.88228 6.59007 6.88228Z"
        fill={color}
      />
      <path
        d="M9.40989 6.88228C9.86387 6.88228 10.2319 6.51426 10.2319 6.06028C10.2319 5.6063 9.86387 5.23828 9.40989 5.23828C8.95591 5.23828 8.58789 5.6063 8.58789 6.06028C8.58789 6.51426 8.95591 6.88228 9.40989 6.88228Z"
        fill={color}
      />
      <path d="M11.501 8.99927H4.50098V10.4993H11.501V8.99927Z" fill={color} />
    </svg>
  );

  icons.mixed = (
    <svg {...svgProps} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 2H4C2.89543 2 2 2.89543 2 4V12C2 13.1046 2.89543 14 4 14H12C13.1046 14 14 13.1046 14 12V4C14 2.89543 13.1046 2 12 2Z"
        fill={secondaryColor}
      />
      <path
        d="M12 2.5H4C3.17157 2.5 2.5 3.17157 2.5 4V12C2.5 12.8284 3.17157 13.5 4 13.5H12C12.8284 13.5 13.5 12.8284 13.5 12V4C13.5 3.17157 12.8284 2.5 12 2.5Z"
        stroke={color}
      />
      <path
        d="M6.0908 7.70528C6.54478 7.70528 6.9128 7.33726 6.9128 6.88328C6.9128 6.4293 6.54478 6.06128 6.0908 6.06128C5.63682 6.06128 5.2688 6.4293 5.2688 6.88328C5.2688 7.33726 5.63682 7.70528 6.0908 7.70528Z"
        fill={color}
      />
      <path
        d="M9.91087 6.88228C10.3648 6.88228 10.7329 6.51426 10.7329 6.06028C10.7329 5.6063 10.3648 5.23828 9.91087 5.23828C9.45689 5.23828 9.08887 5.6063 9.08887 6.06028C9.08887 6.51426 9.45689 6.88228 9.91087 6.88228Z"
        fill={color}
      />
      <path
        d="M11.187 8.11739L4.42578 9.93018L4.81424 11.379L11.5754 9.56622L11.187 8.11739Z"
        fill={color}
      />
    </svg>
  );

  icons.recommendation = (
    <svg {...svgProps} viewBox="0 0 13.994 13.994">
      <g id="Group_5548" data-name="Group 5548" transform="translate(-1249.996 -2621.73)">
        <path
          id="Path_3373"
          data-name="Path 3373"
          d="M1255.623,2636.109h1.25v.625h1.25v-.625h1.25v-1.25h-3.751Z"
          transform="translate(-0.505 -1.01)"
          fill={color}
        />
        <path
          id="Path_3374"
          data-name="Path 3374"
          d="M1256.993,2624.856a3.908,3.908,0,0,0-1.659,7.429v.38a.555.555,0,0,0,.553.557h2.211a.555.555,0,0,0,.554-.557v-.38a3.908,3.908,0,0,0-1.659-7.429Zm.922,6.532a.556.556,0,0,0-.369.525v.194h-1.106v-.194a.557.557,0,0,0-.368-.525,2.765,2.765,0,1,1,1.843,0Z"
          fill={color}
        />
        <rect
          id="Rectangle_3585"
          data-name="Rectangle 3585"
          width="1.25"
          height="2.501"
          transform="translate(1256.368 2621.73)"
          fill={color}
        />
        <rect
          id="Rectangle_3586"
          data-name="Rectangle 3586"
          width="2.501"
          height="1.25"
          transform="translate(1249.996 2628.102)"
          fill={color}
        />
        <rect
          id="Rectangle_3587"
          data-name="Rectangle 3587"
          width="2.501"
          height="1.25"
          transform="translate(1261.489 2628.102)"
          fill={color}
        />
        <rect
          id="Rectangle_3588"
          data-name="Rectangle 3588"
          width="2.652"
          height="1.25"
          transform="translate(1259.797 2625.039) rotate(-45)"
          fill={color}
        />
        <rect
          id="Rectangle_3589"
          data-name="Rectangle 3589"
          width="1.25"
          height="2.652"
          transform="translate(1251.43 2624.047) rotate(-45)"
          fill={color}
        />
      </g>
    </svg>
  );

  icons.lockedFile = (
    <svg {...svgProps} viewBox="0 0 10 13" fill={color} xmlns="http://www.w3.org/2000/svg">
      <g>
        <g>
          <path
            d="M6.66666 6.49964C6.66666 5.59964 5.91666 4.86328 4.99999 4.86328C4.08333 4.86328 3.33333 5.59964 3.33333 6.49964V7.0451H2.77777V10.3178H7.22222V7.0451H6.66666V6.49964ZM4.44444 6.49964C4.44444 6.19964 4.69444 5.95419 4.99999 5.95419C5.30555 5.95419 5.55555 6.19964 5.55555 6.49964V7.0451H4.44444V6.49964ZM6.1111 9.22692H3.88888V8.13601H6.1111V9.22692Z"
            fill={color}
          />
          <path
            d="M7.45 0.5H1.11111C0.5 0.5 0 0.990909 0 1.59091V11.4091C0 12.0091 0.5 12.5 1.11111 12.5H8.88889C9.5 12.5 10 12.0091 10 11.4091V3.00364L7.45 0.5ZM1.11111 11.4091V1.59091H6.66667V3.77273H8.88889V11.4091H1.11111Z"
            fill={color}
          />
        </g>
      </g>
    </svg>
  );

  icons.lockedFileInverted = (
    <svg width="10" height="12" viewBox="0 0 10 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_413_20123)">
        <path
          d="M5.55545 6.00053C5.55545 5.70053 5.30545 5.45508 4.99989 5.45508C4.69434 5.45508 4.44434 5.70053 4.44434 6.00053V7.09144H5.55545V6.00053Z"
          fill={color}
        />
        <path
          d="M7.45 0H1.11111C0.5 0 0 0.490909 0 1.09091V10.9091C0 11.5091 0.5 12 1.11111 12H8.88889C9.5 12 10 11.5091 10 10.9091V2.50364L7.45 0ZM7.22222 9.81818H2.77778V7.09091H3.33333V6C3.33333 5.1 4.08333 4.36364 5 4.36364C5.91667 4.36364 6.66667 5.1 6.66667 6V7.09091H7.22222V9.81818ZM6.66667 3.27273V0.545455L9.44444 3.27273H6.66667Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_413_20123">
          <rect width="10" height="12" fill={Color.white} />
        </clipPath>
      </defs>
    </svg>
  );

  icons.mostPopularTopics = (
    <svg {...svgProps} viewBox="0 0 24 24">
      <g id="Group_5551" data-name="Group 5551" transform="translate(-288 -1641)">
        <g id="Group_3996" data-name="Group 3996">
          <g id="Group_3992" data-name="Group 3992">
            <path
              id="Path_2413"
              data-name="Path 2413"
              d="M306,1665H294v-2a5.006,5.006,0,0,1,5-5h2a5.006,5.006,0,0,1,5,5Zm-10-2h8a3,3,0,0,0-3-3h-2A3,3,0,0,0,296,1663Z"
              fill={Color.blue40}
            />
          </g>
          <g id="Group_3993" data-name="Group 3993">
            <path
              id="Path_2414"
              data-name="Path 2414"
              d="M292,1663a6.961,6.961,0,0,1,.3-2H291a3,3,0,0,0-3,3v1h4Z"
              fill={Color.blue40}
            />
          </g>
          <path
            id="Path_2415"
            data-name="Path 2415"
            d="M295.522,1656.934a2.5,2.5,0,1,0-2.818,3.027A7.026,7.026,0,0,1,295.522,1656.934Z"
            fill={Color.blue40}
          />
          <g id="Group_3994" data-name="Group 3994">
            <path
              id="Path_2416"
              data-name="Path 2416"
              d="M309,1661h-1.3a7,7,0,0,1,.3,2v2h4v-1A3,3,0,0,0,309,1661Z"
              fill={Color.blue40}
            />
          </g>
          <path
            id="Path_2417"
            data-name="Path 2417"
            d="M307.092,1655a2.5,2.5,0,0,0-2.452,2.032,7.036,7.036,0,0,1,2.665,2.947,2.494,2.494,0,0,0-.213-4.979Z"
            fill={Color.blue40}
          />
          <g id="Group_3995" data-name="Group 3995">
            <path
              id="Path_2418"
              data-name="Path 2418"
              d="M300,1658a3,3,0,1,1,3-3A3,3,0,0,1,300,1658Zm0-4a1,1,0,1,0,1,1A1,1,0,0,0,300,1654Z"
              fill={Color.blue40}
            />
          </g>
        </g>
        <path
          id="Path_2419"
          data-name="Path 2419"
          d="M305,1641H295a2,2,0,0,0-2,2v11l3-3h9a2,2,0,0,0,2-2v-6A2,2,0,0,0,305,1641Zm-1,8h-8v-2h8Zm0-4h-8v-2h8Z"
          fill={Color.blue40}
        />
      </g>
    </svg>
  );

  icons.mostPopularTopicsSolid = (
    <svg {...svgProps} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.014 16.014">
      <g id="Popular_solid" data-name="Popular solid" transform="translate(0 0)">
        <g id="Group_4467" data-name="Group 4467" transform="translate(0 7.492)">
          <g id="Group_4465" data-name="Group 4465" transform="translate(0 5.853)">
            <path
              id="Path_2521"
              data-name="Path 2521"
              d="M290.669,1662.334A3.97,3.97,0,0,1,290.9,1661h-.678a2.045,2.045,0,0,0-2.225,2v.667h2.669Z"
              transform="translate(-288 -1661)"
              fill={Color.blue40}
            />
          </g>
          <path
            id="Path_2522"
            data-name="Path 2522"
            d="M293.928,1656.674v-.006a1.668,1.668,0,1,0-1.845,1.651A4.023,4.023,0,0,1,293.928,1656.674Z"
            transform="translate(-288.863 -1653.15)"
            fill={Color.blue40}
          />
          <path
            id="Path_2523"
            data-name="Path 2523"
            d="M306.26,1655a1.668,1.668,0,0,0-1.667,1.668c0,.023.006.045.007.069a4.02,4.02,0,0,1,1.721,1.593,1.666,1.666,0,0,0-.061-3.33Z"
            transform="translate(-293.522 -1653.15)"
            fill={Color.blue40}
          />
          <g id="Group_4466" data-name="Group 4466" transform="translate(13.111 5.853)">
            <path
              id="Path_2524"
              data-name="Path 2524"
              d="M308.328,1661h-.678a3.969,3.969,0,0,1,.234,1.334v1.334h2.669V1663A2.045,2.045,0,0,0,308.328,1661Z"
              transform="translate(-307.65 -1661)"
              fill={Color.blue40}
            />
          </g>
          <path
            id="Path_2525"
            data-name="Path 2525"
            d="M294,1663.035h8.007V1661.7a2.668,2.668,0,0,0-2.1-2.605,3.305,3.305,0,0,1-3.807,0,2.668,2.668,0,0,0-2.1,2.605Z"
            transform="translate(-289.997 -1654.513)"
            fill={Color.blue40}
          />
          <ellipse
            id="Ellipse_139"
            data-name="Ellipse 139"
            cx="2.061"
            cy="1.804"
            rx="2.061"
            ry="1.804"
            transform="translate(5.945 0)"
            fill={Color.blue40}
          />
        </g>
        <path
          id="Path_2526"
          data-name="Path 2526"
          d="M301.007,1641h-6.672a1.335,1.335,0,0,0-1.334,1.335v7.339l2-2h6.005a1.335,1.335,0,0,0,1.335-1.334v-4A1.335,1.335,0,0,0,301.007,1641Zm-.667,5.338H295V1645h5.338Zm0-2.669H295v-1.334h5.338Z"
          transform="translate(-289.664 -1641)"
          fill={Color.blue40}
        />
      </g>
    </svg>
  );

  icons.mostPositiveTopics = (
    <svg {...svgProps} viewBox="0 0 24 24">
      <g id="Group_5550" data-name="Group 5550" transform="translate(-384 -1353)">
        <g id="Group_4002" data-name="Group 4002">
          <path
            id="Path_2420"
            data-name="Path 2420"
            d="M387,1377v-4h-1a2,2,0,0,1-2-2v-9a2,2,0,0,1,2-2h13a2,2,0,0,1,2,2v9a2,2,0,0,1-2,2h-6.667Zm-1-15v9h3v2l2.666-2H399v-9Z"
            fill={Color.green50}
          />
        </g>
        <g id="Group_4003" data-name="Group 4003">
          <path
            id="Path_2421"
            data-name="Path 2421"
            d="M405,1356v-3h-2v3h-3v2h3v3h2v-3h3v-2Z"
            fill={Color.green50}
          />
        </g>
      </g>
    </svg>
  );

  icons.mostPositiveTopicsSolid = (
    <svg
      {...svgProps}
      id="Positive_solid"
      data-name="Positive solid"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
    >
      <path
        id="Path_2527"
        data-name="Path 2527"
        d="M394,1360h-8.667a1.334,1.334,0,0,0-1.333,1.333v6a1.335,1.335,0,0,0,1.333,1.333H386v2.667l3.555-2.667H394a1.335,1.335,0,0,0,1.333-1.333v-6A1.334,1.334,0,0,0,394,1360Z"
        transform="translate(-384 -1355.333)"
        fill={Color.green50}
      />
      <path
        id="Path_2528"
        data-name="Path 2528"
        d="M403.333,1355v-2H402v2h-2v1.333h2v2h1.333v-2h2V1355Z"
        transform="translate(-389.333 -1353)"
        fill={Color.green50}
      />
    </svg>
  );

  icons.categorizedRecommendations = (
    <svg {...svgProps} viewBox="0 0 12 12" fill="none">
      <path
        d="M4.3923 11.464H5.46418V11.9997H6.53607V11.464H7.60795V10.3926H4.39136L4.3923 11.464Z"
        fill={Color.indigo50}
      />
      <path
        d="M6.00002 2.67969C5.24351 2.6867 4.51163 2.94959 3.92345 3.42541C3.33527 3.90123 2.92538 4.56203 2.7605 5.30039C2.59561 6.03875 2.6854 6.81108 3.01528 7.49191C3.34517 8.17275 3.89571 8.72196 4.57737 9.05014V9.37611C4.57714 9.4386 4.58925 9.50042 4.61295 9.55824C4.63666 9.61607 4.6715 9.66881 4.71554 9.71317C4.75957 9.75752 4.81197 9.79267 4.86962 9.8168C4.92728 9.84092 4.98905 9.85342 5.05155 9.85364H6.94755C7.01012 9.85353 7.07204 9.84108 7.12979 9.81701C7.18754 9.79293 7.23996 9.75774 7.28408 9.71338C7.32821 9.66901 7.36322 9.61634 7.38698 9.55845C7.41074 9.50057 7.4228 9.43868 7.42257 9.37611V9.05014C8.10423 8.72196 8.65477 8.17275 8.98465 7.49191C9.31454 6.81108 9.40443 6.03875 9.23954 5.30039C9.07466 4.56203 8.66477 3.90123 8.07659 3.42541C7.48841 2.94959 6.75653 2.6867 6.00002 2.67969ZM6.79064 8.28097C6.69784 8.31411 6.61754 8.37516 6.56088 8.45578C6.50421 8.5364 6.47396 8.63275 6.4742 8.73129V8.89752H5.52573V8.73129C5.52592 8.63289 5.49575 8.53678 5.43927 8.4562C5.38279 8.37562 5.30281 8.31436 5.21024 8.28097C4.68289 8.09456 4.23841 7.72773 3.95538 7.24529C3.67235 6.76286 3.56898 6.19585 3.66354 5.64457C3.75811 5.09329 4.04453 4.59321 4.47217 4.23268C4.8998 3.87216 5.44111 3.67454 6.00044 3.67454C6.55976 3.67454 7.10108 3.87216 7.52871 4.23268C7.95634 4.59321 8.24277 5.09329 8.33734 5.64457C8.4319 6.19585 8.32853 6.76286 8.0455 7.24529C7.76247 7.72773 7.31799 8.09456 6.79064 8.28097Z"
        fill={Color.indigo50}
      />
      <path d="M6.53554 0H5.46411V2.14465H6.53554V0Z" fill={Color.indigo50} />
      <path d="M2.14463 5.46484H0V6.53627H2.14463V5.46484Z" fill={Color.indigo50} />
      <path d="M12.0001 5.46484H9.85547V6.53627H12.0001V5.46484Z" fill={Color.indigo50} />
      <path
        d="M10.0116 1.23053L8.4043 2.83789L9.16191 3.59551L10.7693 1.98815L10.0116 1.23053Z"
        fill={Color.indigo50}
      />
      <path
        d="M1.98735 1.22871L1.22974 1.98633L2.83708 3.59369L3.59469 2.83607L1.98735 1.22871Z"
        fill={Color.indigo50}
      />
    </svg>
  );

  icons.prioritizedRecommendations = (
    <svg {...svgProps} viewBox="0 0 12 12" fill="none">
      <path
        d="M10.8 0H1.2C0.54 0 0 0.54 0 1.2V10.8C0 11.46 0.54 12 1.2 12H10.8C11.46 12 12 11.46 12 10.8V1.2C12 0.54 11.46 0 10.8 0ZM4.974 4.626L4.2 3.852V7.806H3V3.852L2.226 4.626L1.38 3.78L3.606 1.554L5.832 3.78L4.986 4.626H4.974ZM8.4 10.446L6.174 8.22L7.02 7.374L7.794 8.148V4.194H8.994V8.148L9.768 7.374L10.614 8.22L8.388 10.446H8.4Z"
        fill={Color.lightGreen50}
      />
    </svg>
  );

  icons.prioritizedRecommendationsSolid = (
    <svg viewBox="0 0 24 24" fill="none">
      <rect {...svgProps} rx="2" fill={Color.lightGreen10} />
      <g>
        <path
          d="M16.8 6H7.2C6.54 6 6 6.54 6 7.2V16.8C6 17.46 6.54 18 7.2 18H16.8C17.46 18 18 17.46 18 16.8V7.2C18 6.54 17.46 6 16.8 6ZM10.974 10.626L10.2 9.852V13.806H9V9.852L8.226 10.626L7.38 9.78L9.606 7.554L11.832 9.78L10.986 10.626H10.974ZM14.4 16.446L12.174 14.22L13.02 13.374L13.794 14.148V10.194H14.994V14.148L15.768 13.374L16.614 14.22L14.388 16.446H14.4Z"
          fill={Color.lightGreen50}
        />
      </g>
    </svg>
  );

  icons.allSentiments = (
    <svg {...svgProps} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6 0C2.688 0 0 2.688 0 6C0 9.312 2.688 12 6 12C9.312 12 12 9.312 12 6C12 2.688 9.312 0 6 0ZM3.6 2.4C4.26 2.4 4.8 2.934 4.8 3.6C4.8 4.266 4.26 4.8 3.6 4.8C2.94 4.8 2.4 4.26 2.4 3.6C2.4 2.94 2.94 2.4 3.6 2.4ZM9.6 7.2C9.6 8.772 7.884 10.2 6 10.2C4.116 10.2 2.4 8.772 2.4 7.2V6.6H9.6V7.2ZM8.4 4.8C7.74 4.8 7.2 4.26 7.2 3.6C7.2 2.94 7.74 2.4 8.4 2.4C9.06 2.4 9.6 2.934 9.6 3.6C9.6 4.266 9.06 4.8 8.4 4.8Z"
        fill={Color.indigo50}
      />
    </svg>
  );
  icons.allSentimentsSolid = (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect {...svgProps} rx="2" fill={Color.indigo20} />
      <path
        d="M12 6C8.688 6 6 8.688 6 12C6 15.312 8.688 18 12 18C15.312 18 18 15.312 18 12C18 8.688 15.312 6 12 6ZM9.6 8.4C10.26 8.4 10.8 8.934 10.8 9.6C10.8 10.266 10.26 10.8 9.6 10.8C8.94 10.8 8.4 10.26 8.4 9.6C8.4 8.94 8.94 8.4 9.6 8.4ZM15.6 13.2C15.6 14.772 13.884 16.2 12 16.2C10.116 16.2 8.4 14.772 8.4 13.2V12.6H15.6V13.2ZM14.4 10.8C13.74 10.8 13.2 10.26 13.2 9.6C13.2 8.94 13.74 8.4 14.4 8.4C15.06 8.4 15.6 8.934 15.6 9.6C15.6 10.266 15.06 10.8 14.4 10.8Z"
        fill={Color.indigo50}
      />
    </svg>
  );

  icons.mostNegativeTopics = (
    <svg {...svgProps} viewBox="0 0 22 21.006">
      <g id="Group_5552" data-name="Group 5552" transform="translate(-432 -1356)">
        <g id="Group_4007" data-name="Group 4007">
          <g id="Group_4006" data-name="Group 4006">
            <g id="Group_4005" data-name="Group 4005">
              <rect
                id="Rectangle_2477"
                data-name="Rectangle 2477"
                width="6"
                height="2"
                transform="translate(448 1356)"
                fill={color}
              />
            </g>
          </g>
        </g>
        <g id="Group_4008" data-name="Group 4008">
          <path
            id="Path_2422"
            data-name="Path 2422"
            d="M435,1377.006v-4h-1a2,2,0,0,1-2-2v-9a2,2,0,0,1,2-2h13a2,2,0,0,1,2,2v9a2,2,0,0,1-2,2h-6.667Zm-1-15v9h3v2l2.666-2H447v-9Z"
            fill={color}
          />
        </g>
      </g>
    </svg>
  );

  icons.mostNegativeTopicsSolid = (
    <svg {...svgProps} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15.242 14.52">
      <g id="Negative_solid" data-name="Negative solid" transform="translate(0 0.053)">
        <path
          id="Path_2529"
          data-name="Path 2529"
          d="M442.351,1360H433.38a1.381,1.381,0,0,0-1.38,1.38v6.21a1.382,1.382,0,0,0,1.38,1.38h.69v2.76l3.68-2.76h4.6a1.382,1.382,0,0,0,1.38-1.38v-6.21A1.381,1.381,0,0,0,442.351,1360Z"
          transform="translate(-432 -1357.265)"
          fill={color}
        />
        <rect
          id="Rectangle_3228"
          data-name="Rectangle 3228"
          width="5"
          height="2"
          transform="translate(10.242 -0.053)"
          fill={color}
        />
      </g>
    </svg>
  );

  icons.commentChart = (
    <svg {...svgProps} viewBox="0 0 24 24">
      <g id="Group_6613" data-name="Group 6613" transform="translate(-240 -1700)">
        <g id="Group_6584" data-name="Group 6584">
          <path
            id="Path_3618"
            data-name="Path 3618"
            d="M244.8,1724v-4.8h-2.4a2.4,2.4,0,0,1-2.4-2.4v-14.4a2.4,2.4,0,0,1,2.4-2.4h19.2a2.4,2.4,0,0,1,2.4,2.4v14.4a2.4,2.4,0,0,1-2.4,2.4H251.2Zm-2.4-21.6v14.4h4.8v2.4l3.2-2.4h11.2v-14.4Z"
            fill={Color.indigo50}
          />
        </g>
        <g id="Group_6585" data-name="Group 6585">
          <rect
            id="Rectangle_4227"
            data-name="Rectangle 4227"
            width="2.4"
            height="3.6"
            transform="translate(246 1709.6)"
            fill={Color.indigo50}
          />
        </g>
        <g id="Group_6586" data-name="Group 6586">
          <rect
            id="Rectangle_4228"
            data-name="Rectangle 4228"
            width="2.4"
            height="6"
            transform="translate(250.8 1707.2)"
            fill={Color.indigo50}
          />
        </g>
        <g id="Group_6587" data-name="Group 6587">
          <rect
            id="Rectangle_4229"
            data-name="Rectangle 4229"
            width="2.4"
            height="8.4"
            transform="translate(255.6 1704.8)"
            fill={Color.indigo50}
          />
        </g>
      </g>
    </svg>
  );

  icons.gear = (
    <svg {...svgProps} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" fill={color}>
      <path
        id="Path_3381"
        data-name="Path 3381"
        d="M22,7.091V4.909H20.21a4.258,4.258,0,0,0-.431-1.051l1.13-1.132L19.274,1.091l-1.132,1.13A4.2,4.2,0,0,0,17.09,1.79V0h-2.18V1.79a4.212,4.212,0,0,0-1.051.431l-1.132-1.13L11.09,2.726l1.132,1.132a4.308,4.308,0,0,0-.432,1.051H10V7.091h1.789a4.336,4.336,0,0,0,.432,1.052L11.09,9.274l1.637,1.636,1.132-1.13a4.213,4.213,0,0,0,1.051.431V12h2.18V10.21a4.2,4.2,0,0,0,1.052-.431l1.132,1.13,1.636-1.636-1.13-1.13a4.286,4.286,0,0,0,.431-1.052ZM16,8.4A2.4,2.4,0,1,1,18.4,6,2.4,2.4,0,0,1,16,8.4"
        transform="translate(-10)"
        fill={color}
      />
    </svg>
  );

  icons.gearInGear = (
    <svg {...svgProps} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14">
      <defs>
        <clipPath id="clipPath">
          <rect
            id="Rectangle_2596"
            data-name="Rectangle 2596"
            width="14"
            height="14"
            transform="translate(0.495 0.495)"
            fill={color}
          />
        </clipPath>
      </defs>
      <g id="Group_4119" data-name="Group 4119" transform="translate(-0.495 -0.495)">
        <g id="Group_4118" data-name="Group 4118" clipPath="url(#clipPath)">
          <path
            id="Path_2458"
            data-name="Path 2458"
            d="M13.286,9.462H11.73A4.494,4.494,0,1,1,6,3.729V2.172a5.981,5.981,0,0,0-1.869.833L2.991,1.868,1.4,3.458,2.538,4.6A5.955,5.955,0,0,0,1.7,6.464H0v3H1.7a5.948,5.948,0,0,0,.841,1.869L1.4,12.468l1.59,1.59L4.128,12.92A5.955,5.955,0,0,0,6,13.761v1.7h3v-1.7a5.952,5.952,0,0,0,1.869-.841L12,14.058l1.59-1.59-1.137-1.138a5.979,5.979,0,0,0,.833-1.869"
            transform="translate(0 -0.468)"
            fill={color}
          />
          <path
            id="Path_2459"
            data-name="Path 2459"
            d="M17.5,4.429V3.066H16.377a2.66,2.66,0,0,0-.269-.657l.706-.707L15.792.681l-.707.706a2.625,2.625,0,0,0-.657-.269V0H13.066V1.118a2.631,2.631,0,0,0-.657.269L11.7.681,10.681,1.7l.707.707a2.691,2.691,0,0,0-.27.657H10V4.429h1.118a2.708,2.708,0,0,0,.27.657l-.707.706L11.7,6.814l.707-.706a2.631,2.631,0,0,0,.657.269V7.5h1.362V6.377a2.625,2.625,0,0,0,.657-.269l.707.706,1.022-1.022-.706-.706a2.677,2.677,0,0,0,.269-.657Zm-3.748.818a1.5,1.5,0,1,1,1.5-1.5,1.5,1.5,0,0,1-1.5,1.5"
            transform="translate(-2.505)"
            fill={color}
          />
        </g>
      </g>
    </svg>
  );

  icons.group = (
    <svg
      {...svgProps}
      height={size * (9 / 8)}
      viewBox="0 0 16 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.3263 13.6288C13.7654 13.2216 14.0454 12.6425 14.0454 11.9997C14.0454 10.7716 13.0463 9.77246 11.8181 9.77246C10.5899 9.77246 9.59084 10.7716 9.59084 11.9997C9.59084 12.6425 9.87084 13.2216 10.3099 13.6288C9.36811 13.9661 8.63629 14.6216 8.63629 15.4997H9.90902C9.90902 15.1179 10.8063 14.6343 11.8181 14.6343C12.8299 14.6343 13.7272 15.1179 13.7272 15.4997H14.9999C14.9999 14.6216 14.2681 13.9661 13.3263 13.6288ZM11.8181 11.0452C12.3463 11.0452 12.7727 11.4716 12.7727 11.9997C12.7727 12.5279 12.3463 12.9543 11.8181 12.9543C11.2899 12.9543 10.8636 12.5279 10.8636 11.9997C10.8636 11.4716 11.2899 11.0452 11.8181 11.0452Z"
        fill={color}
      />
      <path
        d="M5.69 13.6288C6.12909 13.2216 6.40909 12.6425 6.40909 11.9997C6.40909 10.7716 5.41 9.77246 4.18182 9.77246C2.95364 9.77246 1.95455 10.7716 1.95455 11.9997C1.95455 12.6425 2.23455 13.2216 2.67364 13.6288C1.73182 13.9661 1 14.6216 1 15.4997H2.27273C2.27273 15.1179 3.17 14.6343 4.18182 14.6343C5.19363 14.6343 6.09091 15.1179 6.09091 15.4997H7.36363C7.36363 14.6216 6.63182 13.9661 5.69 13.6288ZM4.18182 11.0452C4.71 11.0452 5.13636 11.4716 5.13636 11.9997C5.13636 12.5279 4.71 12.9543 4.18182 12.9543C3.65364 12.9543 3.22727 12.5279 3.22727 11.9997C3.22727 11.4716 3.65364 11.0452 4.18182 11.0452Z"
        fill={color}
      />
      <path
        d="M9.90905 8.49973H11.1818C11.1818 7.62155 10.45 6.9661 9.50814 6.62882C9.94724 6.22155 10.2272 5.64246 10.2272 4.99973C10.2272 3.77155 9.22814 2.77246 7.99996 2.77246C6.77178 2.77246 5.77269 3.77155 5.77269 4.99973C5.77269 5.64246 6.05269 6.22155 6.49178 6.62882C5.54996 6.9661 4.81815 7.62155 4.81815 8.49973H6.09087C6.09087 8.11791 6.98815 7.63428 7.99996 7.63428C9.01178 7.63428 9.90905 8.11791 9.90905 8.49973ZM7.99996 4.04519C8.52814 4.04519 8.95451 4.47155 8.95451 4.99973C8.95451 5.52791 8.52814 5.95428 7.99996 5.95428C7.47178 5.95428 7.04542 5.52791 7.04542 4.99973C7.04542 4.47155 7.47178 4.04519 7.99996 4.04519Z"
        fill={color}
      />
    </svg>
  );

  icons.info = (
    <svg
      {...svgProps}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill={color}
      className={className}
    >
      <path d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-.001 5.75c.69 0 1.251.56 1.251 1.25s-.561 1.25-1.251 1.25-1.249-.56-1.249-1.25.559-1.25 1.249-1.25zm2.001 12.25h-4v-1c.484-.179 1-.201 1-.735v-4.467c0-.534-.516-.618-1-.797v-1h3v6.265c0 .535.517.558 1 .735v.999z" />
    </svg>
  );

  icons.layout = (
    <svg {...svgProps} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
      <g id="Group_7709" data-name="Group 7709" transform="translate(-892 -3609)">
        <path
          id="Path_3834"
          data-name="Path 3834"
          d="M908,3613v-3.2a.8.8,0,0,0-.8-.8H892.8a.8.8,0,0,0-.8.8v3.2Z"
          fill={color}
        />
        <rect
          id="Rectangle_5401"
          data-name="Rectangle 5401"
          width="4.8"
          height="10.4"
          transform="translate(897.6 3614.6)"
          fill={color}
        />
        <path
          id="Path_3835"
          data-name="Path 3835"
          d="M896,3614.6h-4v9.6a.8.8,0,0,0,.8.8H896Z"
          fill={color}
        />
        <path
          id="Path_3836"
          data-name="Path 3836"
          d="M904,3614.6V3625h3.2a.8.8,0,0,0,.8-.8v-9.6Z"
          fill={color}
        />
      </g>
    </svg>
  );

  icons.share = (
    <svg
      {...svgProps}
      height={size * (17 / 16)}
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.8 10.1C11.84 10.1 10.984 10.532 10.4 11.204L6.328 9.16399C6.376 8.94799 6.4 8.72399 6.4 8.49199C6.4 8.25999 6.376 8.03599 6.328 7.81999L10.4 5.77999C10.984 6.45199 11.84 6.88399 12.8 6.88399C14.568 6.88399 16 5.45199 16 3.68399C16 1.91599 14.568 0.483994 12.8 0.483994C11.032 0.483994 9.6 1.91599 9.6 3.68399C9.6 3.91599 9.624 4.13999 9.672 4.35599L5.6 6.39599C5.016 5.72399 4.16 5.29199 3.2 5.29199C1.432 5.29999 0 6.73199 0 8.49999C0 10.268 1.432 11.7 3.2 11.7C4.16 11.7 5.016 11.268 5.6 10.596L9.672 12.636C9.624 12.852 9.6 13.076 9.6 13.308C9.6 15.076 11.032 16.508 12.8 16.508C14.568 16.508 16 15.076 16 13.308C16 11.54 14.568 10.108 12.8 10.108V10.1ZM12.8 2.09999C13.68 2.09999 14.4 2.81999 14.4 3.69999C14.4 4.57999 13.68 5.29999 12.8 5.29999C11.92 5.29999 11.2 4.57999 11.2 3.69999C11.2 2.81999 11.92 2.09999 12.8 2.09999ZM3.2 10.1C2.32 10.1 1.6 9.37999 1.6 8.49999C1.6 7.61999 2.32 6.89999 3.2 6.89999C4.08 6.89999 4.8 7.61999 4.8 8.49999C4.8 9.37999 4.08 10.1 3.2 10.1ZM12.8 14.9C11.92 14.9 11.2 14.18 11.2 13.3C11.2 12.42 11.92 11.7 12.8 11.7C13.68 11.7 14.4 12.42 14.4 13.3C14.4 14.18 13.68 14.9 12.8 14.9Z"
        fill={color}
      />
    </svg>
  );

  icons.commentSearch = (
    <svg {...svgProps} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15.61 16">
      <g id="Group_7710" data-name="Group 7710" transform="translate(-547.902 -1549)">
        <path
          id="Path_3838"
          data-name="Path 3838"
          d="M558.569,1557a4.667,4.667,0,0,1-4.471-3.333h-4.862A1.334,1.334,0,0,0,547.9,1555v6a1.335,1.335,0,0,0,1.334,1.333h.666V1565l3.556-2.667H557.9a1.335,1.335,0,0,0,1.334-1.333v-4.053A4.737,4.737,0,0,1,558.569,1557Z"
          fill={color}
        />
        <path
          id="Path_3839"
          data-name="Path 3839"
          d="M563.512,1556.333l-2.165-2.164a3.349,3.349,0,1,0-.943.942l2.165,2.165Zm-6.943-4a2,2,0,1,1,2,2A2,2,0,0,1,556.569,1552.333Z"
          fill={color}
        />
      </g>
    </svg>
  );

  icons.hierarchySolid2 = (
    <svg {...svgProps} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 14.546">
      <path
        id="Path_3840"
        data-name="Path 3840"
        d="M906.545,2655.043v-1.588a2.183,2.183,0,0,0-2.181-2.182h-3.637v-2.182h4.364a.726.726,0,0,0,.727-.727v-2.909a.727.727,0,0,0-.727-.728H894.909a.727.727,0,0,0-.727.728v2.909a.726.726,0,0,0,.727.727h4.364v2.182h-3.637a2.183,2.183,0,0,0-2.181,2.182v1.588a2.182,2.182,0,1,0,1.454,0v-1.588a.729.729,0,0,1,.727-.728h3.637v2.316a2.182,2.182,0,1,0,1.454,0v-2.316h3.637a.729.729,0,0,1,.727.728v1.588a2.182,2.182,0,1,0,1.454,0Z"
        transform="translate(-892 -2644.727)"
        fill={color}
      />
    </svg>
  );

  icons.download = (
    <svg {...svgProps} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11.995 9.527">
      <g id="Group_6149" data-name="Group 6149" transform="translate(-237.862 -3872.43)">
        <g id="Group_5801" data-name="Group 5801" transform="translate(237.862 3880.457)">
          <rect
            id="Rectangle_3884"
            data-name="Rectangle 3884"
            width="11.995"
            height="1.499"
            fill={color}
          />
        </g>
        <g id="Group_5802" data-name="Group 5802" transform="translate(238.832 3872.43)">
          <path
            id="Path_3408"
            data-name="Path 3408"
            d="M243.952,3878.208a.747.747,0,0,1-.53-.219l-4.5-4.5,1.06-1.06,3.968,3.968,3.968-3.968,1.06,1.06-4.5,4.5A.75.75,0,0,1,243.952,3878.208Z"
            transform="translate(-238.924 -3872.43)"
            fill={color}
          />
        </g>
      </g>
    </svg>
  );

  icons.change = (
    <svg {...svgProps} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 6 6">
      <g id="Change" transform="translate(-179.958 -2041.958)">
        <g id="Group_219" transform="translate(179.959 2041.958)">
          <g id="alert-circle" transform="translate(0)">
            <path
              id="Shape_645"
              d="M182.954,2041.958a3.048,3.048,0,0,0-2.127.914,2.971,2.971,0,0,0,2.082,5.085h.053a3.028,3.028,0,0,0,3-3.052,2.941,2.941,0,0,0-3-2.948Zm-.371,4.135a.373.373,0,0,1,.1-.268.38.38,0,0,1,.261-.115h.007a.382.382,0,0,1,.381.367.373.373,0,0,1-.1.268.369.369,0,0,1-.261.115h-.007A.381.381,0,0,1,182.584,2046.093Zm.125-2.51v1.5a.25.25,0,1,0,.5,0v-1.5a.25.25,0,1,0-.5,0Z"
              transform="translate(-179.959 -2041.958)"
              fill={color}
            />
          </g>
        </g>
      </g>
    </svg>
  );

  icons.continue = (
    <svg {...svgProps} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 6.344 5.799">
      <g id="Continue" transform="translate(3152.617 -11950.123)">
        <path
          id="Union_1"
          data-name="Union 1"
          d="M-16967.176,20711.521l2.9,2.9-2.9,2.9Zm-3.441,0,2.9,2.9-2.9,2.9Zm2.9,2.9h.006Z"
          transform="translate(13818 -8761.399)"
          fill={color}
        />
      </g>
    </svg>
  );

  icons.stop = (
    <svg {...svgProps} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 4 4">
      <rect id="Stop" width="4" height="4" fill={color} />
    </svg>
  );

  icons.start = (
    <svg {...svgProps} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 4 6">
      <path id="Start" d="M3,0H3L0,4H6L3,0Z" transform="translate(4) rotate(90)" fill={color} />
    </svg>
  );

  icons.doLess = (
    <svg {...svgProps} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 6 4">
      <path
        id="Do_less"
        data-name="Do less"
        d="M3,0H3L0,4H6L3,0Z"
        transform="translate(6 4) rotate(180)"
        fill={color}
      />
    </svg>
  );

  icons.mostAlerts = (
    <svg {...svgProps} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.8988 14.003H3.09821C2.99593 14.0027 2.89542 13.9762 2.80624 13.9261C2.71705 13.876 2.64215 13.8039 2.58865 13.7167C2.53514 13.6295 2.50481 13.53 2.50053 13.4278C2.49624 13.3255 2.51816 13.2239 2.56419 13.1325L7.96446 2.3266C8.01482 2.22827 8.09132 2.14574 8.18554 2.08812C8.27976 2.03049 8.38806 2 8.49849 2C8.60892 2 8.71721 2.03049 8.81144 2.08812C8.90566 2.14574 8.98216 2.22827 9.03252 2.3266L14.4328 13.1325C14.4788 13.2239 14.5007 13.3255 14.4965 13.4278C14.4922 13.53 14.4618 13.6295 14.4083 13.7167C14.3548 13.8039 14.2799 13.876 14.1907 13.9261C14.1016 13.9762 14.001 14.0027 13.8988 14.003ZM4.07026 12.8023H12.9267L8.49849 3.91147L4.07026 12.8023Z"
        fill={color}
      />
      <path d="M9.0985 6.7749H7.89844V10.3769H9.0985V6.7749Z" fill={color} />
      <path
        d="M8.49851 12.3272C8.91275 12.3272 9.24855 11.9914 9.24855 11.5772C9.24855 11.163 8.91275 10.8271 8.49851 10.8271C8.08428 10.8271 7.74847 11.163 7.74847 11.5772C7.74847 11.9914 8.08428 12.3272 8.49851 12.3272Z"
        fill={color}
      />
    </svg>
  );

  icons.doMore = (
    <svg {...svgProps} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 6 4">
      <path
        id="Do_more"
        data-name="Do more"
        d="M3,4H3L0,0H6L3,4Z"
        transform="translate(6 4) rotate(180)"
        fill={color}
      />
    </svg>
  );

  icons.plus = (
    <svg
      {...svgProps}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      stroke={color}
      strokeWidth="3"
      className="is-stroke"
    >
      <line x1="12" y1="5" x2="12" y2="19"></line>
      <line x1="5" y1="12" x2="19" y2="12"></line>
    </svg>
  );

  icons.minus = (
    <svg
      {...svgProps}
      xmlns="http://www.w3.org/2000/svg"
      className="is-stroke"
      viewBox="0 0 24 24"
      fill={color}
      stroke={color}
      strokeWidth="3"
    >
      <line x1="5" y1="12" x2="19" y2="12"></line>
    </svg>
  );

  icons.minusCircle = (
    <svg
      {...svgProps}
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_936_18028)">
        <path
          d="M7 14.5C3.143 14.5 0 11.357 0 7.5C0 3.643 3.143 0.5 7 0.5C10.857 0.5 14 3.643 14 7.5C14 11.357 10.857 14.5 7 14.5ZM7 1.9C3.913 1.9 1.4 4.413 1.4 7.5C1.4 10.587 3.913 13.1 7 13.1C10.087 13.1 12.6 10.587 12.6 7.5C12.6 4.413 10.087 1.9 7 1.9Z"
          fill="#35384D"
        />
        <path d="M10.5 6.80078H3.5V8.20078H10.5V6.80078Z" fill="#35384D" />
      </g>
      <defs>
        <clipPath id="clip0_936_18028">
          <rect width="14" height="14" fill="white" transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </svg>
  );

  icons.export = (
    <svg {...svgProps} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12.536 15.211">
      <g id="Group_5826" data-name="Group 5826" transform="translate(-196 -3899.586)">
        <path
          id="Path_3416"
          data-name="Path 3416"
          d="M201.981,3902.585v7.511h1.567v-7.511l2.58,2.58,1.108-1.108-4.471-4.471-4.471,4.471,1.108,1.108Z"
          transform="translate(-0.496)"
          fill={color}
        />
        <path
          id="Path_3417"
          data-name="Path 3417"
          d="M206.969,3915v1.567h-9.4V3915H196v1.567a1.568,1.568,0,0,0,1.567,1.567h9.4a1.569,1.569,0,0,0,1.567-1.567V3915Z"
          transform="translate(0 -3.337)"
          fill={color}
        />
      </g>
    </svg>
  );

  icons.merge = (
    <svg {...svgProps} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11.994 11.994">
      <g id="Group_6134" data-name="Group 6134" transform="translate(-288.293 -5001.293)">
        <path
          id="Path_3506"
          data-name="Path 3506"
          d="M291.729,5019.073h1.025V5016H289.68v1.024H291l-2.711,2.712.724.724,2.711-2.711Z"
          transform="translate(0 -7.173)"
          fill={color}
        />
        <path
          id="Path_3507"
          data-name="Path 3507"
          d="M306.736,5001.293,304.025,5004v-1.325H303v3.073h3.074v-1.024h-1.325l2.711-2.711Z"
          transform="translate(-7.173)"
          fill={color}
        />
        <path
          id="Path_3508"
          data-name="Path 3508"
          d="M306.074,5017.024V5016H303v3.073h1.025v-1.324l2.711,2.711.724-.724-2.711-2.712Z"
          transform="translate(-7.173 -7.173)"
          fill={color}
        />
        <path
          id="Path_3509"
          data-name="Path 3509"
          d="M289.68,5005.753h3.074v-3.073h-1.025V5004l-2.711-2.711-.724.724,2.711,2.711H289.68Z"
          fill={color}
        />
        <path
          id="Path_3510"
          data-name="Path 3510"
          d="M298.049,5013.1a2.049,2.049,0,1,0-2.049-2.049A2.051,2.051,0,0,0,298.049,5013.1Zm0-3.074a1.025,1.025,0,1,1-1.025,1.025A1.026,1.026,0,0,1,298.049,5010.024Z"
          transform="translate(-3.759 -3.759)"
          fill={color}
        />
      </g>
    </svg>
  );

  icons.notepad = (
    <svg
      {...svgProps}
      id="View_details"
      data-name="View details"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 10 14"
      className="is-stroke"
      color={color}
    >
      <g
        id="Rectangle_5505"
        data-name="Rectangle 5505"
        transform="translate(0 1)"
        stroke={color}
        fill="none"
        strokeWidth="1"
      >
        <rect width="10" height="13" rx="2" stroke="none" />
        <rect x="0.5" y="0.5" width="9" height="12" rx="1.5" fill="none" />
      </g>
      <line
        id="Line_474"
        data-name="Line 474"
        x2="4"
        transform="translate(3.004 6.5)"
        fill="none"
        stroke={color}
        strokeWidth="1"
      />
      <line
        id="Line_475"
        data-name="Line 475"
        x2="4"
        transform="translate(3.004 8.5)"
        fill="none"
        stroke={color}
        strokeWidth="1"
      />
      <line
        id="Line_476"
        data-name="Line 476"
        x2="4"
        transform="translate(3.004 10.5)"
        fill="none"
        stroke={color}
        strokeWidth="1"
      />
      <g
        id="Rectangle_5506"
        data-name="Rectangle 5506"
        transform="translate(2)"
        fill="white"
        stroke={color}
        strokeWidth="1"
      >
        <rect width="6" height="3" stroke="none" />
        <rect x="0.5" y="0.5" width="5" height="2" fill="none" />
      </g>
    </svg>
  );

  icons.mly = (
    <svg {...svgProps} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
      <g id="Group_9305" data-name="Group 9305" transform="translate(-14.963 -15)">
        <path
          id="Path_2446"
          data-name="Path 2446"
          d="M0,28.328V3.672A3.672,3.672,0,0,1,3.672,0H28.328A3.672,3.672,0,0,1,32,3.672V28.328A3.672,3.672,0,0,1,28.328,32H3.672A3.672,3.672,0,0,1,0,28.328"
          transform="translate(14.963 15)"
          fill={color}
        />
        <path
          id="Path_2447"
          data-name="Path 2447"
          d="M38.674,64.789h-1.7v8.53a1.71,1.71,0,0,0,1.71,1.71h1.7V66.5a1.709,1.709,0,0,0-1.709-1.709"
          transform="translate(-15.942 -38.909)"
          fill={secondaryColor}
        />
        <path
          id="Path_2448"
          data-name="Path 2448"
          d="M72.091,64.789h-1.7v8.53a1.71,1.71,0,0,0,1.71,1.71h1.7V66.5a1.709,1.709,0,0,0-1.709-1.709"
          transform="translate(-43.874 -38.909)"
          fill={secondaryColor}
        />
        <path
          id="Path_2449"
          data-name="Path 2449"
          d="M105.508,64.789h-1.7v8.53a1.71,1.71,0,0,0,1.71,1.71h1.7V66.5a1.709,1.709,0,0,0-1.709-1.709"
          transform="translate(-71.807 -38.909)"
          fill={secondaryColor}
        />
        <path
          id="Path_2450"
          data-name="Path 2450"
          d="M139.741,109.615a1.7,1.7,0,0,0-2.516,1.457c0,.015,0,.031,0,.046v1.7h1.705a1.705,1.705,0,0,0,.812-3.2"
          transform="translate(-99.738 -76.452)"
          fill={secondaryColor}
        />
      </g>
    </svg>
  );

  icons.range = (
    <svg {...svgProps} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Icons/Range">
        <g id="Range">
          <path
            id="Vector"
            d="M8 9C8.55228 9 9 8.55228 9 8C9 7.44772 8.55228 7 8 7C7.44772 7 7 7.44772 7 8C7 8.55228 7.44772 9 8 9Z"
            fill={color}
          />
          <path
            id="Vector_2"
            d="M10.9674 11L10 10.0351L12.0583 7.9966L10 5.9581L10.9674 5L14 7.9966L10.9674 11Z"
            fill={color}
          />
          <path
            id="Vector_3"
            d="M5.03259 5L6 5.96489L3.94168 8.0034L6 10.0419L5.03259 11L2 8.0034L5.03259 5Z"
            fill={color}
          />
        </g>
      </g>
    </svg>
  );

  icons.categories = (
    <svg {...svgProps} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.4 7.7998H10.2V7.19995C10.2 6.72256 10.0104 6.26457 9.67279 5.927C9.33523 5.58944 8.87741 5.3999 8.40002 5.3999H6.59998V4.19995H7.79999C7.95912 4.19995 8.11172 4.13669 8.22424 4.02417C8.33677 3.91165 8.40002 3.75898 8.40002 3.59985V0.599854C8.40002 0.440724 8.33677 0.288059 8.22424 0.175537C8.11172 0.0630153 7.95912 0 7.79999 0H4.20001C4.04088 0 3.88828 0.0630153 3.77576 0.175537C3.66323 0.288059 3.59998 0.440724 3.59998 0.599854V3.59985C3.59998 3.75898 3.66323 3.91165 3.77576 4.02417C3.88828 4.13669 4.04088 4.19995 4.20001 4.19995H5.40002V5.3999H3.59998C3.12259 5.3999 2.66477 5.58944 2.32721 5.927C1.98964 6.26457 1.79999 6.72256 1.79999 7.19995V7.7998H0.599976C0.521182 7.7998 0.443157 7.81531 0.370361 7.84546C0.297566 7.87561 0.231435 7.91987 0.17572 7.97559C0.120005 8.0313 0.0758071 8.09762 0.0456543 8.17041C0.0155015 8.24321 0 8.32111 0 8.3999V11.3999C0 11.4787 0.0155015 11.5566 0.0456543 11.6294C0.0758071 11.7022 0.120005 11.7685 0.17572 11.8242C0.231435 11.8799 0.297566 11.9242 0.370361 11.9543C0.443157 11.9845 0.521182 12 0.599976 12H4.20001C4.35914 12 4.51175 11.9367 4.62427 11.8242C4.73679 11.7117 4.79999 11.559 4.79999 11.3999V8.3999C4.79999 8.24077 4.73679 8.08811 4.62427 7.97559C4.51175 7.86306 4.35914 7.7998 4.20001 7.7998H3V7.19995C3 7.04082 3.0632 6.88816 3.17572 6.77563C3.28824 6.66311 3.44085 6.59985 3.59998 6.59985H8.40002C8.47882 6.59985 8.55684 6.61536 8.62964 6.64551C8.70243 6.67566 8.76856 6.71992 8.82428 6.77563C8.88 6.83135 8.92419 6.89742 8.95435 6.97021C8.9845 7.04301 9 7.12116 9 7.19995V7.7998H7.79999C7.64086 7.7998 7.48825 7.86306 7.37573 7.97559C7.26321 8.08811 7.20001 8.24077 7.20001 8.3999V11.3999C7.20001 11.559 7.26321 11.7117 7.37573 11.8242C7.48825 11.9367 7.64086 12 7.79999 12H11.4C11.4788 12 11.5568 11.9845 11.6296 11.9543C11.7024 11.9242 11.7686 11.8799 11.8243 11.8242C11.88 11.7685 11.9242 11.7022 11.9543 11.6294C11.9845 11.5566 12 11.4787 12 11.3999V8.3999C12 8.32111 11.9845 8.24321 11.9543 8.17041C11.9242 8.09762 11.88 8.0313 11.8243 7.97559C11.7686 7.91987 11.7024 7.87561 11.6296 7.84546C11.5568 7.81531 11.4788 7.7998 11.4 7.7998Z"
        fill={color}
      />
    </svg>
  );

  icons.alertNoBgColor = (
    <svg {...svgProps} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.3988 14.003H2.59821C2.49593 14.0027 2.39542 13.9762 2.30624 13.9261C2.21705 13.876 2.14215 13.8039 2.08865 13.7167C2.03514 13.6295 2.00481 13.53 2.00053 13.4278C1.99624 13.3255 2.01816 13.2239 2.06419 13.1325L7.46446 2.3266C7.51482 2.22827 7.59132 2.14574 7.68554 2.08812C7.77976 2.03049 7.88806 2 7.99849 2C8.10892 2 8.21721 2.03049 8.31144 2.08812C8.40566 2.14574 8.48216 2.22827 8.53252 2.3266L13.9328 13.1325C13.9788 13.2239 14.0007 13.3255 13.9965 13.4278C13.9922 13.53 13.9618 13.6295 13.9083 13.7167C13.8548 13.8039 13.7799 13.876 13.6907 13.9261C13.6016 13.9762 13.501 14.0027 13.3988 14.003ZM3.57026 12.8023H12.4267L7.99849 3.91147L3.57026 12.8023Z"
        fill={color}
      />
      <path d="M8.5985 6.77515H7.39844V10.3771H8.5985V6.77515Z" fill={color} />
      <path
        d="M7.99857 12.3272C8.41281 12.3272 8.74861 11.9914 8.74861 11.5772C8.74861 11.163 8.41281 10.8271 7.99857 10.8271C7.58434 10.8271 7.24854 11.163 7.24854 11.5772C7.24854 11.9914 7.58434 12.3272 7.99857 12.3272Z"
        fill={color}
      />
    </svg>
  );

  icons.chevronsLeft = (
    <svg
      {...svgProps}
      viewBox="0 0 24 24"
      fill="none"
      className="is-stroke"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="15 18 9 12 15 6"></polyline>
      <polyline points="15 18 9 12 15 6" transform="translate(9 0)"></polyline>
    </svg>
  );

  icons.chevronsRight = (
    <svg
      {...svgProps}
      viewBox="0 0 24 24"
      fill="none"
      className="is-stroke"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="9 18 15 12 9 6"></polyline>
      <polyline points="9 18 15 12 9 6" transform="translate(9 0)"></polyline>
    </svg>
  );

  icons.commenters = (
    <svg {...svgProps} viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.3262 13.1291C13.7653 12.7218 14.0453 12.1427 14.0453 11.5C14.0453 10.2718 13.0462 9.27271 11.818 9.27271C10.5899 9.27271 9.59078 10.2718 9.59078 11.5C9.59078 12.1427 9.87078 12.7218 10.3099 13.1291C9.36805 13.4663 8.63623 14.1218 8.63623 15H9.90896C9.90896 14.6182 10.8062 14.1345 11.818 14.1345C12.8299 14.1345 13.7271 14.6182 13.7271 15H14.9999C14.9999 14.1218 14.268 13.4663 13.3262 13.1291ZM11.818 10.5454C12.3462 10.5454 12.7726 10.9718 12.7726 11.5C12.7726 12.0282 12.3462 12.4545 11.818 12.4545C11.2899 12.4545 10.8635 12.0282 10.8635 11.5C10.8635 10.9718 11.2899 10.5454 11.818 10.5454Z"
        fill={color}
      />
      <path
        d="M5.69 13.1291C6.12909 12.7218 6.40909 12.1427 6.40909 11.5C6.40909 10.2718 5.41 9.27271 4.18182 9.27271C2.95364 9.27271 1.95455 10.2718 1.95455 11.5C1.95455 12.1427 2.23455 12.7218 2.67364 13.1291C1.73182 13.4663 1 14.1218 1 15H2.27273C2.27273 14.6182 3.17 14.1345 4.18182 14.1345C5.19363 14.1345 6.09091 14.6182 6.09091 15H7.36363C7.36363 14.1218 6.63182 13.4663 5.69 13.1291ZM4.18182 10.5454C4.71 10.5454 5.13636 10.9718 5.13636 11.5C5.13636 12.0282 4.71 12.4545 4.18182 12.4545C3.65364 12.4545 3.22727 12.0282 3.22727 11.5C3.22727 10.9718 3.65364 10.5454 4.18182 10.5454Z"
        fill={color}
      />
      <path
        d="M9.90902 7.99998H11.1817C11.1817 7.12179 10.4499 6.46634 9.50811 6.12907C9.9472 5.72179 10.2272 5.1427 10.2272 4.49998C10.2272 3.2718 9.22811 2.27271 7.99993 2.27271C6.77175 2.27271 5.77266 3.2718 5.77266 4.49998C5.77266 5.1427 6.05266 5.72179 6.49175 6.12907C5.54993 6.46634 4.81812 7.12179 4.81812 7.99998H6.09084C6.09084 7.61816 6.98811 7.13452 7.99993 7.13452C9.01175 7.13452 9.90902 7.61816 9.90902 7.99998ZM7.99993 3.54543C8.52811 3.54543 8.95448 3.9718 8.95448 4.49998C8.95448 5.02816 8.52811 5.45452 7.99993 5.45452C7.47175 5.45452 7.04539 5.02816 7.04539 4.49998C7.04539 3.9718 7.47175 3.54543 7.99993 3.54543Z"
        fill={color}
      />
    </svg>
  );

  icons.warningSolid = (
    <svg {...svgProps} viewBox="0 0 37 33" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.0789 3.60555L0.942417 22.9211C-1.60353 26.9725 1.30825 32.2402 6.09364 32.2402H30.3691C35.1545 32.2402 38.0638 26.9725 35.5203 22.9211L23.3838 3.60555C20.9986 -0.18883 15.4692 -0.18883 13.0839 3.60555H13.0789Z"
        fill={color}
      />
      <path
        d="M19.4116 9.66913C19.6316 9.66913 19.8095 9.84711 19.8095 10.0671V21.3885C19.8095 21.606 19.6316 21.7864 19.4116 21.7864H17.0485C16.831 21.7864 16.6506 21.6085 16.6506 21.3885V10.0671C16.6506 9.84958 16.8285 9.66913 17.0485 9.66913H19.4116ZM19.4116 23.1757C19.6316 23.1757 19.8095 23.3536 19.8095 23.5736V25.9566C19.8095 26.1741 19.6316 26.3545 19.4116 26.3545H17.0485C16.831 26.3545 16.6506 26.1766 16.6506 25.9566V23.5736C16.6506 23.3561 16.8285 23.1757 17.0485 23.1757H19.4116Z"
        fill={secondaryColor}
      />
    </svg>
  );

  icons.windows = (
    <svg {...svgProps} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_202_2017)">
        <path
          d="M6 0H1.33333C0.6 0 0 0.654545 0 1.45455V5.81818C0 6.61818 0.6 7.27273 1.33333 7.27273H6C6.73333 7.27273 7.33333 6.61818 7.33333 5.81818V1.45455C7.33333 0.654545 6.73333 0 6 0ZM6 1.45455V2.18182H1.33333V1.45455H6ZM1.33333 5.81818V3.63636H6V5.81818H1.33333Z"
          fill={color}
        />
        <path
          d="M14.6667 0H10.0001C9.26675 0 8.66675 0.654545 8.66675 1.45455V5.81818C8.66675 6.61818 9.26675 7.27273 10.0001 7.27273H14.6667C15.4001 7.27273 16.0001 6.61818 16.0001 5.81818V1.45455C16.0001 0.654545 15.4001 0 14.6667 0ZM14.6667 1.45455V2.18182H10.0001V1.45455H14.6667ZM10.0001 5.81818V3.63636H14.6667V5.81818H10.0001Z"
          fill={color}
        />
        <path
          d="M6 8.72705H1.33333C0.6 8.72705 0 9.3816 0 10.1816V14.5452C0 15.3452 0.6 15.9998 1.33333 15.9998H6C6.73333 15.9998 7.33333 15.3452 7.33333 14.5452V10.1816C7.33333 9.3816 6.73333 8.72705 6 8.72705ZM6 10.1816V10.9089H1.33333V10.1816H6ZM1.33333 14.5452V12.3634H6V14.5452H1.33333Z"
          fill={color}
        />
        <path
          d="M14.6667 8.72705H10.0001C9.26675 8.72705 8.66675 9.3816 8.66675 10.1816V14.5452C8.66675 15.3452 9.26675 15.9998 10.0001 15.9998H14.6667C15.4001 15.9998 16.0001 15.3452 16.0001 14.5452V10.1816C16.0001 9.3816 15.4001 8.72705 14.6667 8.72705ZM14.6667 10.1816V10.9089H10.0001V10.1816H14.6667ZM10.0001 14.5452V12.3634H14.6667V14.5452H10.0001Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_202_2017">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );

  icons.topicSummary = (
    <svg
      {...svgProps}
      height={(size * 17) / 16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect y="0.5" rx="2" width={size} height={size} fill={secondaryColor} />
      <g clipPath="url(#clip0_43_3414)">
        <path
          d="M12.7999 13.3H10.3999V14.5H12.7999C13.4599 14.5 13.9999 13.96 13.9999 13.3V10.9H12.7999V13.3Z"
          fill={color}
        />
        <path
          d="M12.7999 2.5H10.3999V3.7H12.7999V6.1H13.9999V3.7C13.9999 3.04 13.4599 2.5 12.7999 2.5Z"
          fill={color}
        />
        <path d="M3.2 3.7H5.6V2.5H3.2C2.54 2.5 2 3.04 2 3.7V6.1H3.2V3.7Z" fill={color} />
        <path d="M3.2 10.9H2V13.3C2 13.96 2.54 14.5 3.2 14.5H5.6V13.3H3.2V10.9Z" fill={color} />
        <path
          d="M12.8 8.5C12.8 8.5 10.772 5.5 7.99995 5.5C5.22795 5.5 3.19995 8.5 3.19995 8.5C3.19995 8.5 5.22795 11.5 7.99995 11.5C10.772 11.5 12.8 8.5 12.8 8.5ZM7.99995 10.3C7.00395 10.3 6.19995 9.496 6.19995 8.5C6.19995 7.504 7.00395 6.7 7.99995 6.7C8.99595 6.7 9.79995 7.504 9.79995 8.5C9.79995 9.496 8.99595 10.3 7.99995 10.3Z"
          fill={color}
        />
        <path
          d="M7.9999 9.1C8.33127 9.1 8.5999 8.83137 8.5999 8.5C8.5999 8.16863 8.33127 7.9 7.9999 7.9C7.66853 7.9 7.3999 8.16863 7.3999 8.5C7.3999 8.83137 7.66853 9.1 7.9999 9.1Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_43_3414">
          <rect width="12" height="12" fill="white" transform="translate(2 2.5)" />
        </clipPath>
      </defs>
    </svg>
  );

  icons.allRecommendations = (
    <svg {...svgProps} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_441_21762)">
        <path
          d="M6.38988 13.46H7.45988V14H8.52988V13.46H9.59988V12.39H6.37988V13.46H6.38988Z"
          fill={color}
        />
        <path
          d="M10.9802 9.49005C10.6502 10.1701 10.1002 10.7201 9.42024 11.0501V11.3801C9.42024 11.4401 9.41024 11.5001 9.39024 11.5601C9.36024 11.6201 9.33024 11.6701 9.28024 11.7101C9.24024 11.7601 9.19024 11.7901 9.13024 11.8201C9.07024 11.8401 9.01024 11.8501 8.95024 11.8501H7.05024C6.99024 11.8501 6.93024 11.8401 6.87024 11.8201C6.81024 11.7901 6.76024 11.7601 6.72024 11.7101C6.67024 11.6701 6.64024 11.6201 6.61024 11.5601C6.59024 11.5001 6.58024 11.4401 6.58024 11.3801V11.0501C5.90024 10.7201 5.35024 10.1701 5.02024 9.49005C4.69024 8.81005 4.60024 8.04005 4.76024 7.30005C4.93024 6.56005 5.34024 5.90005 5.92024 5.43005C6.51024 4.95005 7.24024 4.69005 8.00024 4.68005C8.76024 4.69005 9.49024 4.95005 10.0802 5.43005C10.6602 5.90005 11.0702 6.56005 11.2402 7.30005C11.4002 8.04005 11.3102 8.81005 10.9802 9.49005Z"
          fill={color}
        />
        <path d="M8.54022 2H7.47021V4.14H8.54022V2Z" fill={color} />
        <path d="M4.14 7.45996H2V8.52996H4.14V7.45996Z" fill={color} />
        <path d="M13.9999 7.45996H11.8599V8.52996H13.9999V7.45996Z" fill={color} />
        <path
          d="M12.0099 3.22998L10.3999 4.83998L11.1599 5.59998L12.7699 3.98998L12.0099 3.22998Z"
          fill={color}
        />
        <path
          d="M3.98998 3.22998L3.22998 3.98998L4.83998 5.59998L5.59998 4.83998L3.98998 3.22998Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_441_21762">
          <rect width={size} height={size} fill="white" transform="translate(2 2)" />
        </clipPath>
      </defs>
    </svg>
  );

  icons.triangleFilledRight = (
    <svg {...svgProps} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10 8L6 12L6 4L10 8Z" fill={color} />
    </svg>
  );

  icons.rearrangeArrows = (
    <svg {...svgProps} viewBox="0 0 12 12" fill={color} xmlns="http://www.w3.org/2000/svg">
      <g>
        <path
          d="M3.6 4.44605V7.80005H4.8V4.44605L5.574 5.22605L6.426 4.37405L4.2 2.15405L1.974 4.37405L2.826 5.22605L3.6 4.44605Z"
          fill="#A7A9BF"
        />
        <path
          d="M6.42597 6.77395L5.57397 7.62595L7.79997 9.84595L10.026 7.62595L9.17397 6.77395L8.39997 7.55395V4.19995H7.19997V7.55395L6.42597 6.77395Z"
          fill="#A7A9BF"
        />
        <path
          d="M10.8 0H1.2C0.54 0 0 0.54 0 1.2V10.8C0 11.46 0.54 12 1.2 12H10.8C11.46 12 12 11.46 12 10.8V1.2C12 0.54 11.46 0 10.8 0ZM10.8 10.8H1.2V1.2H10.8V10.8Z"
          fill="#A7A9BF"
        />
      </g>
      <defs>
        <clipPath id="clip0_201_2765">
          <rect fill={color} />
        </clipPath>
      </defs>
    </svg>
  );

  icons.commentBubble = (
    <svg {...svgProps} viewBox="0 0 12 12" fill={color} xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.4 12V9.6H1.2C0.54 9.6 0 9.06 0 8.4V1.2C0 0.54 0.54 0 1.2 0H10.8C11.46 0 12 0.54 12 1.2V8.4C12 9.06 11.46 9.6 10.8 9.6H5.598L2.4 12ZM1.2 1.2V8.4H3.6V9.6L5.202 8.4H10.8V1.2H1.2Z"
        fill="#A7A9BF"
      />
    </svg>
  );

  icons.pin = (
    <svg {...svgProps} viewBox="0 0 12 12" fill={color} xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_254_21032)">
        <path
          d="M12 6.22315L5.77685 0L4.89052 0.886328L5.77685 1.77894L2.66527 4.89052L1.77894 3.9979L0.886328 4.89052L3.55788 7.55579L0 11.1137L0.886328 12L4.44421 8.44212L7.10948 11.1137L8.0021 10.2211L7.10948 9.33473L10.2211 6.22315L11.1137 7.10948L12 6.22315Z"
          fill="#4230E5"
        />
      </g>
      <defs>
        <clipPath id="clip0_254_21032">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );

  icons.horn = (
    <svg {...svgProps} viewBox="0 0 12 10" fill={"#000"} xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.8 0V0.705882L1.2 2.79412V2.35294H0V7.05882H1.2V6.61765L1.8 6.74706V8.82353C1.8 9.09412 1.986 9.32941 2.256 9.39412L4.656 9.98235C4.704 9.99412 4.752 10 4.8 10C4.986 10 5.166 9.91765 5.28 9.76471L6.762 7.82941L10.8 8.71177V9.41765H12V0H10.8ZM4.56 8.74706L3 8.36471V7.00588L5.478 7.54706L4.56 8.74706ZM1.2 5.41176V4L10.8 1.90588V7.5L1.2 5.41176Z"
        fill={"#000"}
      />
    </svg>
  );

  icons.minusCircle = (
    <svg {...svgProps} viewBox="0 0 14 14" fill={color} xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_824_17062)">
        <path
          d="M7 14C3.143 14 0 10.857 0 7C0 3.143 3.143 0 7 0C10.857 0 14 3.143 14 7C14 10.857 10.857 14 7 14ZM7 1.4C3.913 1.4 1.4 3.913 1.4 7C1.4 10.087 3.913 12.6 7 12.6C10.087 12.6 12.6 10.087 12.6 7C12.6 3.913 10.087 1.4 7 1.4Z"
          fill="white"
        />
        <path d="M10.5 6.2998H3.5V7.6998H10.5V6.2998Z" fill="white" />
      </g>

      <clipPath id="clip0_824_17062">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </svg>
  );

  icons.lightBulb = (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.39206 11.4635H5.46394V11.9992H6.53583V11.4635H7.60771V10.3921H4.39111L4.39206 11.4635Z"
        fill={color}
      />
      <path
        d="M5.99978 2.68066C5.24327 2.68768 4.51139 2.95057 3.92321 3.42639C3.33503 3.9022 2.92514 4.563 2.76026 5.30137C2.59537 6.03973 2.68515 6.81205 3.01504 7.49289C3.34492 8.17373 3.89546 8.72294 4.57712 9.05112V9.37708C4.5769 9.43958 4.589 9.50139 4.61271 9.55922C4.63642 9.61705 4.67126 9.66979 4.71529 9.71414C4.75933 9.7585 4.81172 9.79365 4.86938 9.81777C4.92703 9.8419 4.98881 9.8544 5.0513 9.85462H6.94731C7.00988 9.85451 7.07179 9.84206 7.12955 9.81798C7.1873 9.79391 7.23971 9.75872 7.28384 9.71435C7.32796 9.66999 7.36297 9.61731 7.38674 9.55943C7.4105 9.50155 7.42255 9.43965 7.42233 9.37708V9.05112C8.10398 8.72294 8.65452 8.17373 8.98441 7.49289C9.31429 6.81205 9.40418 6.03973 9.2393 5.30137C9.07441 4.563 8.66452 3.9022 8.07634 3.42639C7.48816 2.95057 6.75629 2.68768 5.99978 2.68066ZM6.7904 8.28195C6.6976 8.31509 6.61729 8.37614 6.56063 8.45676C6.50397 8.53738 6.47371 8.63373 6.47396 8.73227V8.8985H5.52549V8.73227C5.52567 8.63386 5.49551 8.53776 5.43903 8.45718C5.38254 8.3766 5.30256 8.31534 5.20999 8.28195C4.68265 8.09554 4.23817 7.7287 3.95513 7.24627C3.6721 6.76384 3.56873 6.19682 3.6633 5.64554C3.75786 5.09427 4.04429 4.59418 4.47192 4.23366C4.89955 3.87313 5.44087 3.67552 6.00019 3.67552C6.55952 3.67552 7.10084 3.87313 7.52847 4.23366C7.9561 4.59418 8.24253 5.09427 8.33709 5.64554C8.43166 6.19682 8.32829 6.76384 8.04525 7.24627C7.76222 7.7287 7.31774 8.09554 6.7904 8.28195Z"
        fill="#4230E5"
      />
      <path d="M6.5353 0H5.46387V2.14465H6.5353V0Z" fill="#4230E5" />
      <path d="M2.14463 5.46387H0V6.5353H2.14463V5.46387Z" fill="#4230E5" />
      <path d="M12.0001 5.46387H9.85547V6.5353H12.0001V5.46387Z" fill="#4230E5" />
      <path
        d="M10.0116 1.23004L8.4043 2.8374L9.16191 3.59502L10.7693 1.98766L10.0116 1.23004Z"
        fill="#4230E5"
      />
      <path
        d="M1.9871 1.2292L1.22949 1.98682L2.83684 3.59418L3.59445 2.83656L1.9871 1.2292Z"
        fill="#4230E5"
      />
    </svg>
  );

  return icons[type];
};
